type IconProps = React.ComponentProps<'svg'>

export function ArrowBlockDownIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(4.25, 2.25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.95044 9.91512e-08C10.0779 -4.92736e-07 10.2192 -8.94079e-05 10.3401 0.00976572C10.4697 0.0203838 10.6411 0.0468177 10.8176 0.136719C11.0527 0.256524 11.2437 0.447561 11.3635 0.682617C11.4535 0.85925 11.4799 1.03045 11.4905 1.16016C11.5004 1.2811 11.5002 1.42222 11.5002 1.5498V11H14.7502C15.0535 11 15.3275 11.1827 15.4436 11.4629C15.5596 11.7431 15.495 12.0658 15.2805 12.2803L8.28052 19.2803C7.98761 19.573 7.51281 19.5731 7.21997 19.2803L0.21997 12.2803C0.00564671 12.0658 -0.0590661 11.743 0.056884 11.4629C0.172929 11.1827 0.447023 11.0001 0.750243 11H4.00024V1.5498C4.00024 1.42223 4.00013 1.28109 4.01001 1.16016C4.02063 1.03048 4.04701 0.859216 4.13696 0.682617L4.18481 0.59668C4.30485 0.400923 4.47717 0.241608 4.68286 0.136719L4.81372 0.0800782C4.94235 0.03427 5.06317 0.0177428 5.1604 0.00976572C5.28124 -0.000107212 5.42255 -6.75911e-07 5.55005 9.91512e-08H9.95044ZM5.50024 11.75C5.50024 12.1642 5.16446 12.5 4.75024 12.5H2.56079L7.75024 17.6895L12.9397 12.5H10.7502C10.3362 12.4998 10.0002 12.1641 10.0002 11.75V1.5498C10.0002 1.53224 9.99928 1.51568 9.99927 1.5H5.50024V11.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowBlockLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 4.25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.2196 0.219977C7.43407 0.00566471 7.75685 -0.0590807 8.03699 0.0568916C8.31715 0.172937 8.49975 0.447031 8.49988 0.750251V4.00025H17.9501C18.0776 4.00025 18.2188 4.00014 18.3397 4.01002C18.437 4.01798 18.5577 4.03449 18.6864 4.08033L18.8173 4.13697L18.9032 4.18482C19.0711 4.28776 19.2123 4.42908 19.3153 4.59693L19.3632 4.68287L19.4198 4.81373C19.4656 4.94236 19.4821 5.06318 19.4901 5.16041C19.5 5.28125 19.4999 5.42255 19.4999 5.55006V9.95045C19.4999 10.0779 19.5 10.2192 19.4901 10.3401C19.4795 10.4697 19.4531 10.6411 19.3632 10.8176C19.2434 11.0527 19.0523 11.2437 18.8173 11.3635C18.6407 11.4535 18.4694 11.4799 18.3397 11.4905C18.2188 11.5004 18.0776 11.5003 17.9501 11.5003H8.49988V14.7503C8.49988 15.0535 8.31715 15.3275 8.03699 15.4436C7.75675 15.5597 7.43408 15.495 7.2196 15.2805L0.219604 8.28052C-0.0731578 7.98762 -0.0732451 7.51283 0.219604 7.21998L7.2196 0.219977ZM1.81042 7.75025L6.99988 12.9397V10.7503C7.00005 10.3362 7.33577 10.0003 7.74988 10.0003H17.9501C17.9673 10.0002 17.9835 9.99929 17.9989 9.99927C17.9989 9.98398 17.9999 9.96753 17.9999 9.95045V5.55006C17.9999 5.5326 17.9989 5.51583 17.9989 5.50025H7.74988C7.33566 5.50025 6.99988 5.16446 6.99988 4.75025V2.5608L1.81042 7.75025Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowBlockRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 4.25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.4629 0.056884C11.743 -0.0590661 12.0658 0.00564671 12.2803 0.21997L19.2803 7.21997C19.5731 7.51281 19.573 7.98761 19.2803 8.28052L12.2803 15.2805C12.0658 15.495 11.7431 15.5596 11.4629 15.4436C11.1827 15.3275 11 15.0535 11 14.7502V11.5002H1.5498C1.42222 11.5002 1.2811 11.5004 1.16016 11.4905C1.03045 11.4799 0.85925 11.4535 0.682617 11.3635C0.447561 11.2437 0.256524 11.0527 0.136719 10.8176C0.0468177 10.6411 0.0203838 10.4697 0.00976572 10.3401C-8.94079e-05 10.2192 -4.92736e-07 10.0779 9.91512e-08 9.95044V5.55005C-6.75911e-07 5.42255 -0.000107212 5.28124 0.00976572 5.1604C0.0204057 5.03073 0.0467871 4.85936 0.136719 4.68286L0.18457 4.59692C0.304649 4.40119 0.476895 4.24181 0.682617 4.13696L0.813477 4.08032C0.942205 4.03449 1.0629 4.01797 1.16016 4.01001C1.28109 4.00013 1.42223 4.00024 1.5498 4.00024H11V0.750243C11.0001 0.447023 11.1827 0.172929 11.4629 0.056884ZM12.5 4.75024C12.5 5.16446 12.1642 5.50024 11.75 5.50024H1.5V9.99927C1.51568 9.99928 1.53224 10.0002 1.5498 10.0002H11.75C12.1641 10.0002 12.4998 10.3362 12.5 10.7502V12.9397L17.6895 7.75024L12.5 2.56079V4.75024Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowBlockUpIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(4.25, 2.25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.27659 0.167988C7.5711 -0.0722576 8.00588 -0.0546496 8.2805 0.219746L15.2805 7.21975C15.495 7.43422 15.5596 7.75689 15.4436 8.03713C15.3275 8.31738 15.0536 8.50002 14.7502 8.50002H11.5002V17.9502C11.5002 18.0778 11.5003 18.2189 11.4905 18.3399C11.4798 18.4696 11.4535 18.6408 11.3635 18.8174C11.2437 19.0525 11.0527 19.2435 10.8176 19.3633C10.641 19.4532 10.4697 19.4796 10.3401 19.4903C10.2192 19.5001 10.0779 19.5 9.95042 19.5H5.55003C5.42253 19.5 5.28122 19.5001 5.16038 19.4903C5.03071 19.4796 4.85934 19.4532 4.68284 19.3633C4.44787 19.2435 4.25672 19.0524 4.13695 18.8174C4.04703 18.6408 4.02061 18.4695 4.00999 18.3399C4.00012 18.219 4.00023 18.0778 4.00023 17.9502V8.50002H0.750227C0.447008 8.49989 0.172913 8.31729 0.0568681 8.03713C-0.0590358 7.75698 0.00560968 7.43417 0.219954 7.21975L7.21995 0.219746L7.27659 0.167988ZM2.56077 7.00002H4.75023C5.1644 7.00002 5.50016 7.33586 5.50023 7.75002V17.999C5.51581 17.9991 5.53258 18 5.55003 18H9.95042C9.96751 18 9.98396 17.9991 9.99925 17.999C9.99927 17.9837 10.0002 17.9674 10.0002 17.9502V7.75002C10.0003 7.33597 10.3362 7.00019 10.7502 7.00002H12.9397L7.75023 1.81057L2.56077 7.00002Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowCircleBrokenDownIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          d="M15.1006 1.71191C15.308 1.35351 15.7675 1.2311 16.126 1.43848C19.3371 3.29611 21.5 6.77015 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C3.45566e-07 6.77015 2.16294 3.29611 5.37402 1.43848C5.73251 1.2311 6.19196 1.35351 6.39941 1.71191C6.60678 2.07039 6.48437 2.52984 6.12598 2.7373C3.35919 4.33781 1.5 7.32714 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C15.8586 20 20 15.8586 20 10.75C20 7.32714 18.1408 4.33781 15.374 2.7373C15.0156 2.52984 14.8932 2.07039 15.1006 1.71191Z"
          fill="currentColor"
        />
        <path
          d="M10.75 0C11.1642 0 11.5 0.335786 11.5 0.75V12.9395L14.2197 10.2197C14.5126 9.92683 14.9874 9.92683 15.2803 10.2197C15.5732 10.5126 15.5732 10.9874 15.2803 11.2803L11.2803 15.2803C10.9874 15.5732 10.5126 15.5732 10.2197 15.2803L6.21973 11.2803C5.92683 10.9874 5.92683 10.5126 6.21973 10.2197C6.51262 9.92683 6.98738 9.92683 7.28027 10.2197L10 12.9395V0.75C10 0.335786 10.3358 0 10.75 0Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowCircleBrokenDownLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          d="M3.14845 3.14797C5.96269 0.333721 9.94902 -0.592379 13.5332 0.364766C13.9332 0.471741 14.1713 0.882629 14.0645 1.28273C13.9573 1.68233 13.5463 1.92044 13.1465 1.81398C10.0584 0.989312 6.62931 1.7882 4.20899 4.20852C0.596955 7.82089 0.596746 13.6783 4.20899 17.2905C7.82125 20.9026 13.6787 20.9025 17.291 17.2905C19.7113 14.8703 20.5101 11.4411 19.6856 8.35305C19.5791 7.95319 19.8171 7.54211 20.2168 7.43508C20.6169 7.32823 21.0278 7.56629 21.1348 7.96633C22.0918 11.5504 21.1657 15.5369 18.3516 18.3511C14.1535 22.5489 7.34649 22.549 3.14845 18.3511C-1.04959 14.1531 -1.04938 7.34613 3.14845 3.14797Z"
          fill="currentColor"
        />
        <path
          d="M17.2197 3.21926C17.5126 2.92636 17.9874 2.92637 18.2803 3.21926C18.573 3.51216 18.5731 3.98696 18.2803 4.2798L9.56056 12.9995H13.75C14.1642 12.9995 14.5 13.3353 14.5 13.7495C14.4998 14.1635 14.1641 14.4995 13.75 14.4995H7.75001C7.33613 14.4993 7.00026 14.1634 7.00001 13.7495V7.74953C7.00001 7.33545 7.33598 6.99975 7.75001 6.99953C8.16422 6.99953 8.50001 7.33532 8.50001 7.74953V11.939L17.2197 3.21926Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowCircleBrokenDownRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          d="M7.96627 0.364704C11.5504 -0.59232 15.5369 0.333731 18.351 3.14791C22.5487 7.34608 22.549 14.153 18.351 18.351C14.153 22.549 7.34608 22.5487 3.14791 18.351C0.333732 15.5369 -0.59232 11.5504 0.364704 7.96627C0.471679 7.56623 0.882567 7.32817 1.28267 7.43502C1.68223 7.54216 1.92038 7.95322 1.81392 8.35299C0.989371 11.441 1.78821 14.8702 4.20845 17.2905C7.82084 20.9024 13.6783 20.9027 17.2905 17.2905C20.9027 13.6783 20.9024 7.82084 17.2905 4.20845C14.8702 1.78821 11.441 0.989371 8.35299 1.81392C7.95322 1.92038 7.54216 1.68222 7.43502 1.28267C7.32817 0.882567 7.56623 0.471679 7.96627 0.364704Z"
          fill="currentColor"
        />
        <path
          d="M3.2192 3.2192C3.51209 2.9263 3.98685 2.92631 4.27974 3.2192L12.9995 11.9389V7.74947C12.9995 7.3353 13.3353 6.99954 13.7495 6.99947C14.1635 6.99972 14.4995 7.33541 14.4995 7.74947V13.7495C14.4992 14.1633 14.1633 14.4992 13.7495 14.4995H7.74947C7.33547 14.4994 6.99972 14.1634 6.99947 13.7495C6.99947 13.3353 7.33532 12.9995 7.74947 12.9995H11.9389L3.2192 4.27974C2.9263 3.98685 2.9263 3.51209 3.2192 3.2192Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowCircleBrokenLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          d="M10.75 0C14.7298 4.4573e-05 18.2039 2.16298 20.0615 5.37402C20.2688 5.73247 20.1464 6.19194 19.7881 6.39941C19.4296 6.60677 18.9702 6.48433 18.7627 6.12598C17.1622 3.35922 14.1728 1.50004 10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C14.1728 20 17.1622 18.1408 18.7627 15.374C18.9702 15.0157 19.4296 14.8932 19.7881 15.1006C20.1464 15.3081 20.2688 15.7675 20.0615 16.126C18.2039 19.337 14.7298 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 4.81294 4.81294 0 10.75 0Z"
          fill="currentColor"
        />
        <path
          d="M10.2197 6.21973C10.5126 5.92691 10.9874 5.92689 11.2803 6.21973C11.5731 6.5126 11.5731 6.9874 11.2803 7.28027L8.56055 10H20.75C21.1642 10.0001 21.5 10.3358 21.5 10.75C21.5 11.1642 21.1642 11.4999 20.75 11.5H8.56055L11.2803 14.2197C11.5731 14.5126 11.5731 14.9874 11.2803 15.2803C10.9874 15.5731 10.5126 15.5731 10.2197 15.2803L6.21973 11.2803C5.92688 10.9874 5.92688 10.5126 6.21973 10.2197L10.2197 6.21973Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowCircleBrokenRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          d="M10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C6.77016 21.5 3.29609 19.3371 1.43848 16.126C1.23111 15.7675 1.35355 15.3081 1.71191 15.1006C2.07038 14.8932 2.52983 15.0157 2.7373 15.374C4.3378 18.1408 7.32717 20 10.75 20C15.8586 20 20 15.8586 20 10.75C20 5.64137 15.8586 1.5 10.75 1.5C7.32717 1.50003 4.33779 3.35921 2.7373 6.12598C2.52983 6.48434 2.07038 6.60678 1.71191 6.39941C1.35355 6.19194 1.23111 5.73249 1.43848 5.37402C3.29609 2.16295 6.77016 2.52257e-05 10.75 0Z"
          fill="currentColor"
        />
        <path
          d="M10.2197 6.21973C10.5126 5.92683 10.9874 5.92683 11.2803 6.21973L15.2803 10.2197C15.4209 10.3604 15.5 10.5511 15.5 10.75C15.5 10.9489 15.4209 11.1396 15.2803 11.2803L11.2803 15.2803C10.9874 15.5732 10.5126 15.5732 10.2197 15.2803C9.92683 14.9874 9.92683 14.5126 10.2197 14.2197L12.9395 11.5H0.75C0.335786 11.5 0 11.1642 0 10.75C0 10.3358 0.335786 10 0.75 10H12.9395L10.2197 7.28027C9.92683 6.98738 9.92683 6.51262 10.2197 6.21973Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowCircleBrokenUpIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          d="M10.2764 6.16797C10.5709 5.9277 11.0057 5.94517 11.2803 6.21973L15.2803 10.2197C15.5732 10.5126 15.5731 10.9874 15.2803 11.2803C14.9874 11.5732 14.5126 11.5732 14.2197 11.2803L11.5 8.56055V20.75C11.5 21.1642 11.1642 21.5 10.75 21.5C10.3358 21.5 10 21.1642 10 20.75V8.56055L7.28027 11.2803C6.98738 11.5732 6.51262 11.5732 6.21973 11.2803C5.92687 10.9874 5.92684 10.5126 6.21973 10.2197L10.2197 6.21973L10.2764 6.16797Z"
          fill="currentColor"
        />
        <path
          d="M10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 14.7299 19.3371 18.2039 16.126 20.0615C15.7675 20.2689 15.308 20.1465 15.1006 19.7881C14.8932 19.4296 15.0156 18.9702 15.374 18.7627C18.1408 17.1622 20 14.1729 20 10.75C20 5.64137 15.8586 1.5 10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 14.1729 3.35919 17.1622 6.12598 18.7627C6.48437 18.9702 6.60678 19.4296 6.39941 19.7881C6.19196 20.1465 5.73251 20.2689 5.37402 20.0615C2.16294 18.2039 6.91118e-07 14.7299 0 10.75C0 4.81294 4.81294 5.15406e-07 10.75 0Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowCircleBrokenUpLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          d="M3.14852 3.14852C7.3466 -1.04956 14.1535 -1.04945 18.3516 3.14852C21.1659 5.96275 22.092 9.94912 21.1348 13.5333C21.0279 13.9333 20.617 14.1714 20.2169 14.0645C19.8171 13.9575 19.5791 13.5465 19.6856 13.1466C20.5103 10.0585 19.7114 6.62937 17.2911 4.20907C13.6787 0.596881 7.82136 0.596771 4.20907 4.20907C0.596771 7.82136 0.596881 13.6787 4.20907 17.2911C6.62937 19.7114 10.0585 20.5103 13.1466 19.6856C13.5465 19.5791 13.9575 19.8171 14.0645 20.2169C14.1714 20.617 13.9333 21.0279 13.5333 21.1348C9.94912 22.092 5.96275 21.1659 3.14852 18.3516C-1.04945 14.1535 -1.04956 7.3466 3.14852 3.14852Z"
          fill="currentColor"
        />
        <path
          d="M13.7501 7.00008C14.1642 7.00008 14.4999 7.33599 14.5001 7.75008C14.5001 8.1643 14.1643 8.50008 13.7501 8.50008H9.56063L18.2804 17.2198C18.5732 17.5127 18.5732 17.9875 18.2804 18.2804C17.9875 18.5732 17.5127 18.5732 17.2198 18.2804L8.50008 9.56063V13.7501C8.50008 14.1643 8.1643 14.5001 7.75008 14.5001C7.33605 14.4999 7.00008 14.1642 7.00008 13.7501V7.75008C7.00023 7.33612 7.33614 7.0003 7.75008 7.00008H13.7501Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowCircleBrokenUpRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          d="M3.14797 3.14845C7.34613 -1.04938 14.1531 -1.04959 18.3511 3.14845C22.549 7.34649 22.5489 14.1535 18.3511 18.3516C15.5369 21.1657 11.5504 22.0918 7.96633 21.1348C7.56629 21.0278 7.32823 20.6169 7.43508 20.2168C7.54211 19.8171 7.95319 19.5791 8.35305 19.6856C11.4411 20.5101 14.8703 19.7113 17.2905 17.291C20.9025 13.6787 20.9026 7.82125 17.2905 4.20899C13.6783 0.596746 7.82089 0.596955 4.20852 4.20899C1.7882 6.62931 0.989312 10.0584 1.81398 13.1465C1.92044 13.5463 1.68233 13.9573 1.28273 14.0645C0.882629 14.1713 0.471741 13.9332 0.364766 13.5332C-0.592379 9.94903 0.333721 5.96269 3.14797 3.14845Z"
          fill="currentColor"
        />
        <path
          d="M13.7495 7.00001C14.1634 7.00026 14.4994 7.33607 14.4995 7.75001V13.75C14.4995 14.1641 14.1635 14.4998 13.7495 14.5C13.3354 14.4999 12.9995 14.1642 12.9995 13.75V9.56056L4.2798 18.2803C3.98696 18.5731 3.51216 18.573 3.21926 18.2803C2.92637 17.9874 2.92636 17.5126 3.21926 17.2197L11.939 8.50001H7.74953C7.33538 8.49993 6.99953 8.16418 6.99953 7.75001C6.99968 7.33596 7.33547 7.00008 7.74953 7.00001H13.7495Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowCircleDownIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          d="M10.75 6C11.1642 6 11.5 6.33579 11.5 6.75V12.9395L14.2197 10.2197C14.5126 9.92683 14.9874 9.92683 15.2803 10.2197C15.5732 10.5126 15.5732 10.9874 15.2803 11.2803L11.2803 15.2803C10.9874 15.5732 10.5126 15.5732 10.2197 15.2803L6.21973 11.2803C5.92683 10.9874 5.92683 10.5126 6.21973 10.2197C6.51262 9.92683 6.98738 9.92683 7.28027 10.2197L10 12.9395V6.75C10 6.33579 10.3358 6 10.75 6Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 4.81294 4.81294 0 10.75 0ZM10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C15.8586 20 20 15.8586 20 10.75C20 5.64137 15.8586 1.5 10.75 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowCircleDownLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          d="M13.2197 7.21973C13.5126 6.92685 13.9874 6.9269 14.2803 7.21973C14.5732 7.51262 14.5732 7.98738 14.2803 8.28027L9.56055 13H13.75C14.1642 13 14.5 13.3358 14.5 13.75C14.5 14.1642 14.1642 14.5 13.75 14.5H7.75C7.33587 14.4999 7 14.1642 7 13.75V7.75C7.00003 7.33587 7.33589 7.0001 7.75 7C8.1642 7 8.49997 7.33581 8.5 7.75V11.9395L13.2197 7.21973Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 4.81294 4.81294 0 10.75 0ZM10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C15.8586 20 20 15.8586 20 10.75C20 5.64137 15.8586 1.5 10.75 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowCircleDownRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          d="M13.75 7C14.1642 7 14.5 7.33581 14.5 7.75V13.75C14.5 14.1642 14.1642 14.5 13.75 14.5H7.75C7.33587 14.4999 7 14.1642 7 13.75C7.00003 13.3359 7.33589 13.0001 7.75 13H11.9395L7.21973 8.28027C6.92694 7.98742 6.92698 7.51261 7.21973 7.21973C7.5126 6.92686 7.98738 6.9269 8.28027 7.21973L13 11.9395V7.75C13 7.33587 13.3359 7.0001 13.75 7Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 4.81294 4.81294 0 10.75 0ZM10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C15.8586 20 20 15.8586 20 10.75C20 5.64137 15.8586 1.5 10.75 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowCircleLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          d="M10.2197 6.21973C10.5126 5.92683 10.9874 5.92683 11.2803 6.21973C11.5732 6.51262 11.5732 6.98738 11.2803 7.28027L8.56055 10H14.75C15.1642 10 15.5 10.3358 15.5 10.75C15.5 11.1642 15.1642 11.5 14.75 11.5H8.56055L11.2803 14.2197C11.5732 14.5126 11.5732 14.9874 11.2803 15.2803C10.9874 15.5732 10.5126 15.5732 10.2197 15.2803L6.21973 11.2803C5.92683 10.9874 5.92683 10.5126 6.21973 10.2197L10.2197 6.21973Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 4.81294 4.81294 0 10.75 0ZM10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C15.8586 20 20 15.8586 20 10.75C20 5.64137 15.8586 1.5 10.75 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowCircleRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          d="M10.2197 6.21973C10.5126 5.92683 10.9874 5.92683 11.2803 6.21973L15.2803 10.2197C15.5732 10.5126 15.5732 10.9874 15.2803 11.2803L11.2803 15.2803C10.9874 15.5732 10.5126 15.5732 10.2197 15.2803C9.92683 14.9874 9.92683 14.5126 10.2197 14.2197L12.9395 11.5H6.75C6.33579 11.5 6 11.1642 6 10.75C6 10.3358 6.33579 10 6.75 10H12.9395L10.2197 7.28027C9.92683 6.98738 9.92683 6.51262 10.2197 6.21973Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 4.81294 4.81294 0 10.75 0ZM10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C15.8586 20 20 15.8586 20 10.75C20 5.64137 15.8586 1.5 10.75 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowCircleUpIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          d="M10.2764 6.16797C10.5709 5.92766 11.0057 5.94512 11.2803 6.21973L15.2803 10.2197C15.5732 10.5126 15.5732 10.9874 15.2803 11.2803C14.9874 11.5732 14.5126 11.5732 14.2197 11.2803L11.5 8.56055V14.75C11.5 15.1642 11.1642 15.5 10.75 15.5C10.3358 15.5 10 15.1642 10 14.75V8.56055L7.28027 11.2803C6.98738 11.5732 6.51262 11.5732 6.21973 11.2803C5.92683 10.9874 5.92683 10.5126 6.21973 10.2197L10.2197 6.21973L10.2764 6.16797Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 4.81294 4.81294 0 10.75 0ZM10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C15.8586 20 20 15.8586 20 10.75C20 5.64137 15.8586 1.5 10.75 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowCircleUpLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          d="M13.75 7C14.1642 7 14.5 7.33581 14.5 7.75C14.5 8.16421 14.1642 8.5 13.75 8.5H9.56055L14.2803 13.2197C14.5732 13.5126 14.5732 13.9874 14.2803 14.2803C13.9874 14.573 13.5126 14.5731 13.2197 14.2803L8.5 9.56055V13.75C8.5 14.1642 8.16421 14.5 7.75 14.5C7.33587 14.4999 7 14.1642 7 13.75V7.75C7.00003 7.33587 7.33589 7.0001 7.75 7H13.75Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 4.81294 4.81294 0 10.75 0ZM10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C15.8586 20 20 15.8586 20 10.75C20 5.64137 15.8586 1.5 10.75 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowCircleUpRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 1.25)">
        <path
          d="M13.75 7C14.1642 7 14.5 7.33581 14.5 7.75V13.75C14.5 14.1642 14.1642 14.5 13.75 14.5C13.3359 14.4999 13 14.1642 13 13.75V9.56055L8.28027 14.2803C7.98737 14.573 7.51258 14.5731 7.21973 14.2803C6.92694 13.9874 6.92698 13.5126 7.21973 13.2197L11.9395 8.5H7.75C7.33587 8.4999 7 8.16415 7 7.75C7.00003 7.33587 7.33589 7.0001 7.75 7H13.75Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.75 0C16.6871 0 21.5 4.81294 21.5 10.75C21.5 16.6871 16.6871 21.5 10.75 21.5C4.81294 21.5 0 16.6871 0 10.75C0 4.81294 4.81294 0 10.75 0ZM10.75 1.5C5.64137 1.5 1.5 5.64137 1.5 10.75C1.5 15.8586 5.64137 20 10.75 20C15.8586 20 20 15.8586 20 10.75C20 5.64137 15.8586 1.5 10.75 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowDownIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(4.25, 4.25)">
        <path
          d="M7.74994 0C8.16413 3.06649e-05 8.49994 0.335805 8.49994 0.75V12.9395L14.2197 7.21973C14.5126 6.92686 14.9873 6.92684 15.2802 7.21973C15.5731 7.51261 15.5731 7.98739 15.2802 8.28027L8.28022 15.2803C7.98733 15.5732 7.51257 15.5731 7.21967 15.2803L0.21967 8.28027C-0.0732233 7.98738 -0.0732233 7.51262 0.21967 7.21973C0.512565 6.92686 0.987333 6.92684 1.28022 7.21973L6.99994 12.9395V0.75C6.99994 0.335786 7.33573 0 7.74994 0Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowDownLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(6.25, 6.25)">
        <path
          d="M10.2197 0.219727C10.5126 -0.0731667 10.9874 -0.0731667 11.2803 0.219727C11.5732 0.51262 11.5732 0.98738 11.2803 1.28027L2.56055 10H10.75C11.1642 10 11.5 10.3358 11.5 10.75C11.5 11.1642 11.1642 11.5 10.75 11.5H0.75C0.335786 11.5 0 11.1642 0 10.75V0.75C0 0.335786 0.335786 0 0.75 0C1.16421 0 1.5 0.335786 1.5 0.75V8.93945L10.2197 0.219727Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowDownRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(6.25, 6.25)">
        <path
          d="M10.75 0C11.1642 0 11.5 0.335786 11.5 0.75V10.75C11.5 11.1642 11.1642 11.5 10.75 11.5H0.75C0.335786 11.5 0 11.1642 0 10.75C0 10.3358 0.335786 10 0.75 10H8.93945L0.219727 1.28027C-0.0731667 0.98738 -0.0731667 0.51262 0.219727 0.219727C0.51262 -0.0731667 0.98738 -0.0731667 1.28027 0.219727L10 8.93945V0.75C10 0.335786 10.3358 0 10.75 0Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(4.25, 4.25)">
        <path
          d="M7.21967 0.21967C7.51256 -0.0732233 7.98732 -0.0732233 8.28022 0.21967C8.57305 0.512568 8.57309 0.987342 8.28022 1.28022L2.56049 6.99994H14.7499C15.1641 6.99997 15.4999 7.33575 15.4999 7.74994C15.4999 8.16411 15.1641 8.49991 14.7499 8.49994H2.56049L8.28022 14.2197C8.57305 14.5126 8.57309 14.9873 8.28022 15.2802C7.98734 15.5731 7.51257 15.5731 7.21967 15.2802L0.21967 8.28022C-0.0732233 7.98732 -0.0732233 7.51256 0.21967 7.21967L7.21967 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowNarrowDownIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(5.25, 3.25)">
        <path
          d="M6.74994 0C7.16413 3.04072e-05 7.49994 0.335805 7.49994 0.75V14.9395L12.2197 10.2197C12.5126 9.92686 12.9873 9.92684 13.2802 10.2197C13.5731 10.5126 13.5731 10.9874 13.2802 11.2803L7.28022 17.2803C6.98733 17.5732 6.51257 17.5731 6.21967 17.2803L0.21967 11.2803C-0.0732233 10.9874 -0.0732233 10.5126 0.21967 10.2197C0.512565 9.92686 0.987333 9.92684 1.28022 10.2197L5.99994 14.9395V0.75C5.99994 0.335786 6.33573 0 6.74994 0Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowNarrowDownLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(5.25, 5.25)">
        <path
          d="M12.2197 0.21967C12.5126 -0.0732233 12.9874 -0.0732233 13.2803 0.21967C13.5731 0.512565 13.5732 0.987333 13.2803 1.28022L2.56055 11.9999H8.75C9.16421 11.9999 9.5 12.3357 9.5 12.7499C9.49997 13.1641 9.16419 13.4999 8.75 13.4999H0.75C0.335805 13.4999 3.04072e-05 13.1641 0 12.7499V4.74994C0 4.33573 0.335786 3.99994 0.75 3.99994C1.16421 3.99994 1.5 4.33573 1.5 4.74994V10.9394L12.2197 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowNarrowDownRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(5.25, 5.25)">
        <path
          d="M0.21967 0.21967C0.512563 -0.0732233 0.987324 -0.0732233 1.28022 0.21967L11.9999 10.9394V4.74994C11.9999 4.33573 12.3357 3.99994 12.7499 3.99994C13.1641 3.99997 13.4999 4.33575 13.4999 4.74994V12.7499C13.4999 13.1641 13.1641 13.4999 12.7499 13.4999H4.74994C4.33575 13.4999 3.99997 13.1641 3.99994 12.7499C3.99994 12.3357 4.33573 11.9999 4.74994 11.9999H10.9394L0.21967 1.28022C-0.0732233 0.987324 -0.0732233 0.512563 0.21967 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowNarrowLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(3.25, 5.25)">
        <path
          d="M6.21967 0.21967C6.51256 -0.0732233 6.98732 -0.0732233 7.28022 0.21967C7.57305 0.512568 7.57309 0.987342 7.28022 1.28022L2.56049 5.99994H16.7499C17.1641 5.99997 17.4999 6.33575 17.4999 6.74994C17.4999 7.16411 17.1641 7.49991 16.7499 7.49994H2.56049L7.28022 12.2197C7.57305 12.5126 7.57309 12.9873 7.28022 13.2802C6.98734 13.5731 6.51257 13.5731 6.21967 13.2802L0.21967 7.28022C-0.0732233 6.98732 -0.0732233 6.51256 0.21967 6.21967L6.21967 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowNarrowRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(3.25, 5.25)">
        <path
          d="M10.2197 0.21967C10.5126 -0.0732233 10.9874 -0.0732233 11.2803 0.21967L17.2803 6.21967C17.5731 6.51257 17.5732 6.98733 17.2803 7.28022L11.2803 13.2802C10.9874 13.5731 10.5126 13.5731 10.2197 13.2802C9.92684 12.9873 9.92686 12.5126 10.2197 12.2197L14.9395 7.49994H0.75C0.335805 7.49994 3.04072e-05 7.16413 0 6.74994C0 6.33573 0.335786 5.99994 0.75 5.99994H14.9395L10.2197 1.28022C9.92684 0.987333 9.92686 0.512565 10.2197 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowNarrowUpIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(5.25, 3.25)">
        <path
          d="M6.2763 0.168031C6.57086 -0.0721909 7.00562 -0.0547575 7.2802 0.219789L13.2802 6.21979C13.5731 6.51265 13.573 6.98744 13.2802 7.28034C12.9873 7.57323 12.5125 7.57323 12.2197 7.28034L7.49993 2.56061V16.7501C7.49993 17.1643 7.16412 17.5 6.74993 17.5001C6.33571 17.5001 5.99993 17.1643 5.99993 16.7501V2.56061L1.2802 7.28034C0.987308 7.57323 0.512548 7.57323 0.219655 7.28034C-0.0732083 6.98744 -0.0732283 6.51267 0.219655 6.21979L6.21966 0.219789L6.2763 0.168031Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowNarrowUpLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(5.25, 5.25)">
        <path
          d="M8.75 0C9.16421 0 9.5 0.335786 9.5 0.75C9.5 1.16421 9.16421 1.5 8.75 1.5H2.56055L13.2803 12.2197C13.5732 12.5126 13.5732 12.9874 13.2803 13.2803C12.9874 13.5732 12.5126 13.5732 12.2197 13.2803L1.5 2.56055V8.75C1.5 9.16421 1.16421 9.5 0.75 9.5C0.335786 9.5 0 9.16421 0 8.75V0.75C0 0.335786 0.335786 0 0.75 0H8.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowNarrowUpRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(5.25, 5.25)">
        <path
          d="M12.7499 0C13.1641 3.04072e-05 13.4999 0.335805 13.4999 0.75V8.75C13.4999 9.16419 13.1641 9.49997 12.7499 9.5C12.3357 9.5 11.9999 9.16421 11.9999 8.75V2.56055L1.28022 13.2803C0.987333 13.5732 0.512565 13.5731 0.21967 13.2803C-0.0732233 12.9874 -0.0732233 12.5126 0.21967 12.2197L10.9394 1.5H4.74994C4.33573 1.5 3.99994 1.16421 3.99994 0.75C3.99994 0.335786 4.33573 0 4.74994 0H12.7499Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(4.25, 4.25)">
        <path
          d="M7.21973 0.21967C7.51262 -0.0732233 7.98738 -0.0732233 8.28027 0.21967L15.2803 7.21967C15.5731 7.51257 15.5732 7.98733 15.2803 8.28022L8.28027 15.2802C7.98739 15.5731 7.51261 15.5731 7.21973 15.2802C6.92684 14.9873 6.92686 14.5126 7.21973 14.2197L12.9395 8.49994H0.75C0.335805 8.49994 3.06649e-05 8.16413 0 7.74994C0 7.33573 0.335786 6.99994 0.75 6.99994H12.9395L7.21973 1.28022C6.92684 0.987333 6.92686 0.512565 7.21973 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowsDownIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 3.25)">
        <path
          d="M4.74994 0C5.16413 3.06649e-05 5.49994 0.335805 5.49994 0.75V14.9395L8.21967 12.2197C8.51257 11.9269 8.98733 11.9268 9.28022 12.2197C9.57307 12.5126 9.57307 12.9874 9.28022 13.2803L5.28022 17.2803C4.98733 17.5732 4.51257 17.5731 4.21967 17.2803L0.21967 13.2803C-0.0732233 12.9874 -0.0732233 12.5126 0.21967 12.2197C0.512565 11.9269 0.987333 11.9268 1.28022 12.2197L3.99994 14.9395V0.75C3.99994 0.335786 4.33573 0 4.74994 0Z"
          fill="currentColor"
        />
        <path
          d="M14.7499 0C15.1641 3.06649e-05 15.4999 0.335805 15.4999 0.75V9.93945L18.2197 7.21973C18.5126 6.92686 18.9873 6.92684 19.2802 7.21973C19.5731 7.51261 19.5731 7.98739 19.2802 8.28027L15.2802 12.2803C14.9873 12.5732 14.5126 12.5731 14.2197 12.2803L10.2197 8.28027C9.92678 7.98738 9.92678 7.51262 10.2197 7.21973C10.5126 6.92686 10.9873 6.92684 11.2802 7.21973L13.9999 9.93945V0.75C13.9999 0.335786 14.3357 0 14.7499 0Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowsLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(3.25, 2.25)">
        <path
          d="M4.21967 10.2197C4.51256 9.92678 4.98732 9.92678 5.28022 10.2197C5.57305 10.5126 5.57309 10.9873 5.28022 11.2802L2.56049 13.9999H16.7499C17.1641 14 17.4999 14.3357 17.4999 14.7499C17.4999 15.1641 17.1641 15.4999 16.7499 15.4999H2.56049L5.28022 18.2197C5.57305 18.5126 5.57309 18.9873 5.28022 19.2802C4.98734 19.5731 4.51257 19.5731 4.21967 19.2802L0.21967 15.2802C-0.0732233 14.9873 -0.0732233 14.5126 0.21967 14.2197L4.21967 10.2197Z"
          fill="currentColor"
        />
        <path
          d="M9.21967 0.21967C9.51256 -0.0732233 9.98732 -0.0732233 10.2802 0.21967C10.5731 0.512568 10.5731 0.987343 10.2802 1.28022L7.56049 3.99994H16.7499C17.1641 3.99997 17.4999 4.33575 17.4999 4.74994C17.4999 5.16411 17.1641 5.49991 16.7499 5.49994H7.56049L10.2802 8.21967C10.5731 8.51257 10.5731 8.98734 10.2802 9.28022C9.98734 9.57309 9.51257 9.57305 9.21967 9.28022L5.21967 5.28022C5.07903 5.13958 4.99996 4.94884 4.99994 4.74994C4.99994 4.55103 5.07902 4.36032 5.21967 4.21967L9.21967 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowSquareDownIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 2.25)">
        <path
          d="M9.75 5C10.1642 5 10.5 5.33579 10.5 5.75V11.9395L13.2197 9.21973C13.5126 8.92684 13.9874 8.92684 14.2803 9.21973C14.5732 9.51262 14.5732 9.98738 14.2803 10.2803L10.2803 14.2803C9.98738 14.5732 9.51262 14.5732 9.21973 14.2803L5.21973 10.2803C4.92684 9.98738 4.92684 9.51262 5.21973 9.21973C5.51262 8.92684 5.98738 8.92684 6.28028 9.21973L9 11.9395V5.75C9 5.33579 9.33579 5 9.75 5Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9502 1.74497e-06C14.7778 1.65386e-06 15.4436 -0.000968084 15.9814 0.0429705C16.5281 0.0876302 17.008 0.182866 17.4522 0.409181C18.1578 0.768706 18.7313 1.34225 19.0908 2.04785C19.3171 2.49205 19.4124 2.97195 19.457 3.51856C19.501 4.05639 19.5 4.72222 19.5 5.54981V13.9502C19.5 14.7778 19.501 15.4436 19.457 15.9814C19.4124 16.5281 19.3171 17.008 19.0908 17.4522C18.7313 18.1578 18.1578 18.7313 17.4522 19.0908C17.008 19.3171 16.5281 19.4124 15.9814 19.457C15.4436 19.501 14.7778 19.5 13.9502 19.5H5.54981C4.72222 19.5 4.05639 19.501 3.51856 19.457C2.97195 19.4124 2.49205 19.3171 2.04785 19.0908C1.34225 18.7313 0.768706 18.1578 0.409181 17.4522C0.182866 17.008 0.0876302 16.5281 0.0429705 15.9814C-0.000968147 15.4436 1.65333e-06 14.7778 1.74489e-06 13.9502V5.54981C1.65225e-06 4.72222 -0.000968195 4.05639 0.0429705 3.51856C0.0876303 2.97195 0.182866 2.49205 0.409181 2.04785C0.768706 1.34225 1.34225 0.768706 2.04785 0.409181C2.49205 0.182866 2.97195 0.0876303 3.51856 0.0429705C4.05639 -0.000968207 4.72222 1.65211e-06 5.54981 1.74497e-06H13.9502ZM5.54981 1.5C4.69746 1.5 4.10322 1.50029 3.64063 1.53809C3.1868 1.57517 2.92602 1.64449 2.72852 1.74512C2.30515 1.96083 1.96083 2.30515 1.74512 2.72852C1.64449 2.92602 1.57517 3.1868 1.53809 3.64063C1.50029 4.10322 1.5 4.69746 1.5 5.54981V13.9502C1.5 14.8025 1.50029 15.3968 1.53809 15.8594C1.57517 16.3132 1.64449 16.574 1.74512 16.7715C1.96083 17.1949 2.30515 17.5392 2.72852 17.7549C2.92602 17.8555 3.1868 17.9248 3.64063 17.9619C4.10322 17.9997 4.69746 18 5.54981 18H13.9502C14.8025 18 15.3968 17.9997 15.8594 17.9619C16.3132 17.9248 16.574 17.8555 16.7715 17.7549C17.1949 17.5392 17.5392 17.1949 17.7549 16.7715C17.8555 16.574 17.9248 16.3132 17.9619 15.8594C17.9997 15.3968 18 14.8025 18 13.9502V5.54981C18 4.69746 17.9997 4.10322 17.9619 3.64063C17.9248 3.1868 17.8555 2.92602 17.7549 2.72852C17.5392 2.30515 17.1949 1.96083 16.7715 1.74512C16.574 1.64449 16.3132 1.57517 15.8594 1.53809C15.3968 1.50029 14.8025 1.5 13.9502 1.5H5.54981Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowSquareDownLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 2.25)">
        <path
          d="M12.2197 6.21973C12.5126 5.92685 12.9874 5.9269 13.2803 6.21973C13.5732 6.51262 13.5732 6.98738 13.2803 7.28028L8.56055 12H12.75C13.1642 12 13.5 12.3358 13.5 12.75C13.5 13.1642 13.1642 13.5 12.75 13.5H6.75C6.33587 13.4999 6 13.1642 6 12.75V6.75C6.00003 6.33588 6.33589 6.0001 6.75 6C7.1642 6 7.49997 6.33581 7.5 6.75V10.9395L12.2197 6.21973Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9502 1.74497e-06C14.7778 1.65386e-06 15.4436 -0.000968084 15.9814 0.0429705C16.5281 0.0876302 17.008 0.182866 17.4522 0.409181C18.1578 0.768706 18.7313 1.34225 19.0908 2.04785C19.3171 2.49205 19.4124 2.97195 19.457 3.51856C19.501 4.05639 19.5 4.72222 19.5 5.54981V13.9502C19.5 14.7778 19.501 15.4436 19.457 15.9814C19.4124 16.5281 19.3171 17.008 19.0908 17.4522C18.7313 18.1578 18.1578 18.7313 17.4522 19.0908C17.008 19.3171 16.5281 19.4124 15.9814 19.457C15.4436 19.501 14.7778 19.5 13.9502 19.5H5.54981C4.72222 19.5 4.05639 19.501 3.51856 19.457C2.97195 19.4124 2.49205 19.3171 2.04785 19.0908C1.34225 18.7313 0.768706 18.1578 0.409181 17.4522C0.182866 17.008 0.0876302 16.5281 0.0429705 15.9814C-0.000968147 15.4436 1.65333e-06 14.7778 1.74489e-06 13.9502V5.54981C1.65225e-06 4.72222 -0.000968195 4.05639 0.0429705 3.51856C0.0876303 2.97195 0.182866 2.49205 0.409181 2.04785C0.768706 1.34225 1.34225 0.768706 2.04785 0.409181C2.49205 0.182866 2.97195 0.0876303 3.51856 0.0429705C4.05639 -0.000968207 4.72222 1.65211e-06 5.54981 1.74497e-06H13.9502ZM5.54981 1.5C4.69746 1.5 4.10322 1.50029 3.64063 1.53809C3.1868 1.57517 2.92602 1.64449 2.72852 1.74512C2.30515 1.96083 1.96083 2.30515 1.74512 2.72852C1.64449 2.92602 1.57517 3.1868 1.53809 3.64063C1.50029 4.10322 1.5 4.69746 1.5 5.54981V13.9502C1.5 14.8025 1.50029 15.3968 1.53809 15.8594C1.57517 16.3132 1.64449 16.574 1.74512 16.7715C1.96083 17.1949 2.30515 17.5392 2.72852 17.7549C2.92602 17.8555 3.1868 17.9248 3.64063 17.9619C4.10322 17.9997 4.69746 18 5.54981 18H13.9502C14.8025 18 15.3968 17.9997 15.8594 17.9619C16.3132 17.9248 16.574 17.8555 16.7715 17.7549C17.1949 17.5392 17.5392 17.1949 17.7549 16.7715C17.8555 16.574 17.9248 16.3132 17.9619 15.8594C17.9997 15.3968 18 14.8025 18 13.9502V5.54981C18 4.69746 17.9997 4.10322 17.9619 3.64063C17.9248 3.1868 17.8555 2.92602 17.7549 2.72852C17.5392 2.30515 17.1949 1.96083 16.7715 1.74512C16.574 1.64449 16.3132 1.57517 15.8594 1.53809C15.3968 1.50029 14.8025 1.5 13.9502 1.5H5.54981Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowSquareDownRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 2.25)">
        <path
          d="M12.75 6C13.1642 6 13.5 6.33581 13.5 6.75V12.75C13.5 13.1642 13.1642 13.5 12.75 13.5H6.75C6.33587 13.4999 6 13.1642 6 12.75C6.00003 12.3359 6.33589 12.0001 6.75 12H10.9395L6.21973 7.28028C5.92694 6.98742 5.92698 6.51261 6.21973 6.21973C6.5126 5.92686 6.98738 5.9269 7.28028 6.21973L12 10.9395V6.75C12 6.33588 12.3359 6.0001 12.75 6Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9502 1.74497e-06C14.7778 1.65386e-06 15.4436 -0.000968084 15.9814 0.0429705C16.5281 0.0876302 17.008 0.182866 17.4522 0.409181C18.1578 0.768706 18.7313 1.34225 19.0908 2.04785C19.3171 2.49205 19.4124 2.97195 19.457 3.51856C19.501 4.05639 19.5 4.72222 19.5 5.54981V13.9502C19.5 14.7778 19.501 15.4436 19.457 15.9814C19.4124 16.5281 19.3171 17.008 19.0908 17.4522C18.7313 18.1578 18.1578 18.7313 17.4522 19.0908C17.008 19.3171 16.5281 19.4124 15.9814 19.457C15.4436 19.501 14.7778 19.5 13.9502 19.5H5.54981C4.72222 19.5 4.05639 19.501 3.51856 19.457C2.97195 19.4124 2.49205 19.3171 2.04785 19.0908C1.34225 18.7313 0.768706 18.1578 0.409181 17.4522C0.182866 17.008 0.0876302 16.5281 0.0429705 15.9814C-0.000968147 15.4436 1.65333e-06 14.7778 1.74489e-06 13.9502V5.54981C1.65225e-06 4.72222 -0.000968195 4.05639 0.0429705 3.51856C0.0876303 2.97195 0.182866 2.49205 0.409181 2.04785C0.768706 1.34225 1.34225 0.768706 2.04785 0.409181C2.49205 0.182866 2.97195 0.0876303 3.51856 0.0429705C4.05639 -0.000968207 4.72222 1.65211e-06 5.54981 1.74497e-06H13.9502ZM5.54981 1.5C4.69746 1.5 4.10322 1.50029 3.64063 1.53809C3.1868 1.57517 2.92602 1.64449 2.72852 1.74512C2.30515 1.96083 1.96083 2.30515 1.74512 2.72852C1.64449 2.92602 1.57517 3.1868 1.53809 3.64063C1.50029 4.10322 1.5 4.69746 1.5 5.54981V13.9502C1.5 14.8025 1.50029 15.3968 1.53809 15.8594C1.57517 16.3132 1.64449 16.574 1.74512 16.7715C1.96083 17.1949 2.30515 17.5392 2.72852 17.7549C2.92602 17.8555 3.1868 17.9248 3.64063 17.9619C4.10322 17.9997 4.69746 18 5.54981 18H13.9502C14.8025 18 15.3968 17.9997 15.8594 17.9619C16.3132 17.9248 16.574 17.8555 16.7715 17.7549C17.1949 17.5392 17.5392 17.1949 17.7549 16.7715C17.8555 16.574 17.9248 16.3132 17.9619 15.8594C17.9997 15.3968 18 14.8025 18 13.9502V5.54981C18 4.69746 17.9997 4.10322 17.9619 3.64063C17.9248 3.1868 17.8555 2.92602 17.7549 2.72852C17.5392 2.30515 17.1949 1.96083 16.7715 1.74512C16.574 1.64449 16.3132 1.57517 15.8594 1.53809C15.3968 1.50029 14.8025 1.5 13.9502 1.5H5.54981Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowSquareLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 2.25)">
        <path
          d="M9.21973 5.21973C9.51262 4.92684 9.98738 4.92684 10.2803 5.21973C10.5732 5.51262 10.5732 5.98738 10.2803 6.28028L7.56055 9H13.75C14.1642 9 14.5 9.33579 14.5 9.75C14.5 10.1642 14.1642 10.5 13.75 10.5H7.56055L10.2803 13.2197C10.5732 13.5126 10.5732 13.9874 10.2803 14.2803C9.98738 14.5732 9.51262 14.5732 9.21973 14.2803L5.21973 10.2803C4.92684 9.98738 4.92684 9.51262 5.21973 9.21973L9.21973 5.21973Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9502 1.74497e-06C14.7778 1.65386e-06 15.4436 -0.000968084 15.9814 0.0429705C16.5281 0.0876302 17.008 0.182866 17.4522 0.409181C18.1578 0.768706 18.7313 1.34225 19.0908 2.04785C19.3171 2.49205 19.4124 2.97195 19.457 3.51856C19.501 4.05639 19.5 4.72222 19.5 5.54981V13.9502C19.5 14.7778 19.501 15.4436 19.457 15.9814C19.4124 16.5281 19.3171 17.008 19.0908 17.4522C18.7313 18.1578 18.1578 18.7313 17.4522 19.0908C17.008 19.3171 16.5281 19.4124 15.9814 19.457C15.4436 19.501 14.7778 19.5 13.9502 19.5H5.54981C4.72222 19.5 4.05639 19.501 3.51856 19.457C2.97195 19.4124 2.49205 19.3171 2.04785 19.0908C1.34225 18.7313 0.768706 18.1578 0.409181 17.4522C0.182866 17.008 0.0876302 16.5281 0.0429705 15.9814C-0.000968147 15.4436 1.65333e-06 14.7778 1.74489e-06 13.9502V5.54981C1.65225e-06 4.72222 -0.000968195 4.05639 0.0429705 3.51856C0.0876303 2.97195 0.182866 2.49205 0.409181 2.04785C0.768706 1.34225 1.34225 0.768706 2.04785 0.409181C2.49205 0.182866 2.97195 0.0876303 3.51856 0.0429705C4.05639 -0.000968207 4.72222 1.65211e-06 5.54981 1.74497e-06H13.9502ZM5.54981 1.5C4.69746 1.5 4.10322 1.50029 3.64063 1.53809C3.1868 1.57517 2.92602 1.64449 2.72852 1.74512C2.30515 1.96083 1.96083 2.30515 1.74512 2.72852C1.64449 2.92602 1.57517 3.1868 1.53809 3.64063C1.50029 4.10322 1.5 4.69746 1.5 5.54981V13.9502C1.5 14.8025 1.50029 15.3968 1.53809 15.8594C1.57517 16.3132 1.64449 16.574 1.74512 16.7715C1.96083 17.1949 2.30515 17.5392 2.72852 17.7549C2.92602 17.8555 3.1868 17.9248 3.64063 17.9619C4.10322 17.9997 4.69746 18 5.54981 18H13.9502C14.8025 18 15.3968 17.9997 15.8594 17.9619C16.3132 17.9248 16.574 17.8555 16.7715 17.7549C17.1949 17.5392 17.5392 17.1949 17.7549 16.7715C17.8555 16.574 17.9248 16.3132 17.9619 15.8594C17.9997 15.3968 18 14.8025 18 13.9502V5.54981C18 4.69746 17.9997 4.10322 17.9619 3.64063C17.9248 3.1868 17.8555 2.92602 17.7549 2.72852C17.5392 2.30515 17.1949 1.96083 16.7715 1.74512C16.574 1.64449 16.3132 1.57517 15.8594 1.53809C15.3968 1.50029 14.8025 1.5 13.9502 1.5H5.54981Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowSquareRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 2.25)">
        <path
          d="M9.21973 5.21973C9.51262 4.92684 9.98738 4.92684 10.2803 5.21973L14.2803 9.21973C14.5732 9.51262 14.5732 9.98738 14.2803 10.2803L10.2803 14.2803C9.98738 14.5732 9.51262 14.5732 9.21973 14.2803C8.92684 13.9874 8.92684 13.5126 9.21973 13.2197L11.9395 10.5H5.75C5.33579 10.5 5 10.1642 5 9.75C5 9.33579 5.33579 9 5.75 9H11.9395L9.21973 6.28028C8.92684 5.98738 8.92684 5.51262 9.21973 5.21973Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9502 1.74497e-06C14.7778 1.65386e-06 15.4436 -0.000968084 15.9814 0.0429705C16.5281 0.0876302 17.008 0.182866 17.4522 0.409181C18.1578 0.768706 18.7313 1.34225 19.0908 2.04785C19.3171 2.49205 19.4124 2.97195 19.457 3.51856C19.501 4.05639 19.5 4.72222 19.5 5.54981V13.9502C19.5 14.7778 19.501 15.4436 19.457 15.9814C19.4124 16.5281 19.3171 17.008 19.0908 17.4522C18.7313 18.1578 18.1578 18.7313 17.4522 19.0908C17.008 19.3171 16.5281 19.4124 15.9814 19.457C15.4436 19.501 14.7778 19.5 13.9502 19.5H5.54981C4.72222 19.5 4.05639 19.501 3.51856 19.457C2.97195 19.4124 2.49205 19.3171 2.04785 19.0908C1.34225 18.7313 0.768706 18.1578 0.409181 17.4522C0.182866 17.008 0.0876302 16.5281 0.0429705 15.9814C-0.000968147 15.4436 1.65333e-06 14.7778 1.74489e-06 13.9502V5.54981C1.65225e-06 4.72222 -0.000968195 4.05639 0.0429705 3.51856C0.0876303 2.97195 0.182866 2.49205 0.409181 2.04785C0.768706 1.34225 1.34225 0.768706 2.04785 0.409181C2.49205 0.182866 2.97195 0.0876303 3.51856 0.0429705C4.05639 -0.000968207 4.72222 1.65211e-06 5.54981 1.74497e-06H13.9502ZM5.54981 1.5C4.69746 1.5 4.10322 1.50029 3.64063 1.53809C3.1868 1.57517 2.92602 1.64449 2.72852 1.74512C2.30515 1.96083 1.96083 2.30515 1.74512 2.72852C1.64449 2.92602 1.57517 3.1868 1.53809 3.64063C1.50029 4.10322 1.5 4.69746 1.5 5.54981V13.9502C1.5 14.8025 1.50029 15.3968 1.53809 15.8594C1.57517 16.3132 1.64449 16.574 1.74512 16.7715C1.96083 17.1949 2.30515 17.5392 2.72852 17.7549C2.92602 17.8555 3.1868 17.9248 3.64063 17.9619C4.10322 17.9997 4.69746 18 5.54981 18H13.9502C14.8025 18 15.3968 17.9997 15.8594 17.9619C16.3132 17.9248 16.574 17.8555 16.7715 17.7549C17.1949 17.5392 17.5392 17.1949 17.7549 16.7715C17.8555 16.574 17.9248 16.3132 17.9619 15.8594C17.9997 15.3968 18 14.8025 18 13.9502V5.54981C18 4.69746 17.9997 4.10322 17.9619 3.64063C17.9248 3.1868 17.8555 2.92602 17.7549 2.72852C17.5392 2.30515 17.1949 1.96083 16.7715 1.74512C16.574 1.64449 16.3132 1.57517 15.8594 1.53809C15.3968 1.50029 14.8025 1.5 13.9502 1.5H5.54981Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowSquareUpIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 2.25)">
        <path
          d="M9.27637 5.16797C9.57095 4.92766 10.0057 4.94513 10.2803 5.21973L14.2803 9.21973C14.5732 9.51262 14.5732 9.98738 14.2803 10.2803C13.9874 10.5732 13.5126 10.5732 13.2197 10.2803L10.5 7.56055V13.75C10.5 14.1642 10.1642 14.5 9.75 14.5C9.33579 14.5 9 14.1642 9 13.75V7.56055L6.28028 10.2803C5.98738 10.5732 5.51262 10.5732 5.21973 10.2803C4.92684 9.98738 4.92684 9.51262 5.21973 9.21973L9.21973 5.21973L9.27637 5.16797Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9502 1.74497e-06C14.7778 1.65386e-06 15.4436 -0.000968084 15.9814 0.0429705C16.5281 0.0876302 17.008 0.182866 17.4522 0.409181C18.1578 0.768706 18.7313 1.34225 19.0908 2.04785C19.3171 2.49205 19.4124 2.97195 19.457 3.51856C19.501 4.05639 19.5 4.72222 19.5 5.54981V13.9502C19.5 14.7778 19.501 15.4436 19.457 15.9814C19.4124 16.5281 19.3171 17.008 19.0908 17.4522C18.7313 18.1578 18.1578 18.7313 17.4522 19.0908C17.008 19.3171 16.5281 19.4124 15.9814 19.457C15.4436 19.501 14.7778 19.5 13.9502 19.5H5.54981C4.72222 19.5 4.05639 19.501 3.51856 19.457C2.97195 19.4124 2.49205 19.3171 2.04785 19.0908C1.34225 18.7313 0.768706 18.1578 0.409181 17.4522C0.182866 17.008 0.0876302 16.5281 0.0429705 15.9814C-0.000968147 15.4436 1.65333e-06 14.7778 1.74489e-06 13.9502V5.54981C1.65225e-06 4.72222 -0.000968195 4.05639 0.0429705 3.51856C0.0876303 2.97195 0.182866 2.49205 0.409181 2.04785C0.768706 1.34225 1.34225 0.768706 2.04785 0.409181C2.49205 0.182866 2.97195 0.0876303 3.51856 0.0429705C4.05639 -0.000968207 4.72222 1.65211e-06 5.54981 1.74497e-06H13.9502ZM5.54981 1.5C4.69746 1.5 4.10322 1.50029 3.64063 1.53809C3.1868 1.57517 2.92602 1.64449 2.72852 1.74512C2.30515 1.96083 1.96083 2.30515 1.74512 2.72852C1.64449 2.92602 1.57517 3.1868 1.53809 3.64063C1.50029 4.10322 1.5 4.69746 1.5 5.54981V13.9502C1.5 14.8025 1.50029 15.3968 1.53809 15.8594C1.57517 16.3132 1.64449 16.574 1.74512 16.7715C1.96083 17.1949 2.30515 17.5392 2.72852 17.7549C2.92602 17.8555 3.1868 17.9248 3.64063 17.9619C4.10322 17.9997 4.69746 18 5.54981 18H13.9502C14.8025 18 15.3968 17.9997 15.8594 17.9619C16.3132 17.9248 16.574 17.8555 16.7715 17.7549C17.1949 17.5392 17.5392 17.1949 17.7549 16.7715C17.8555 16.574 17.9248 16.3132 17.9619 15.8594C17.9997 15.3968 18 14.8025 18 13.9502V5.54981C18 4.69746 17.9997 4.10322 17.9619 3.64063C17.9248 3.1868 17.8555 2.92602 17.7549 2.72852C17.5392 2.30515 17.1949 1.96083 16.7715 1.74512C16.574 1.64449 16.3132 1.57517 15.8594 1.53809C15.3968 1.50029 14.8025 1.5 13.9502 1.5H5.54981Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowSquareUpLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 2.25)">
        <path
          d="M12.75 6C13.1642 6 13.5 6.33581 13.5 6.75C13.5 7.16422 13.1642 7.5 12.75 7.5H8.56055L13.2803 12.2197C13.5732 12.5126 13.5732 12.9874 13.2803 13.2803C12.9874 13.573 12.5126 13.5731 12.2197 13.2803L7.5 8.56055V12.75C7.5 13.1642 7.16422 13.5 6.75 13.5C6.33587 13.4999 6 13.1642 6 12.75V6.75C6.00003 6.33588 6.33589 6.0001 6.75 6H12.75Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9502 1.74497e-06C14.7778 1.65386e-06 15.4436 -0.000968084 15.9814 0.0429705C16.5281 0.0876302 17.008 0.182866 17.4522 0.409181C18.1578 0.768706 18.7313 1.34225 19.0908 2.04785C19.3171 2.49205 19.4124 2.97195 19.457 3.51856C19.501 4.05639 19.5 4.72222 19.5 5.54981V13.9502C19.5 14.7778 19.501 15.4436 19.457 15.9814C19.4124 16.5281 19.3171 17.008 19.0908 17.4522C18.7313 18.1578 18.1578 18.7313 17.4522 19.0908C17.008 19.3171 16.5281 19.4124 15.9814 19.457C15.4436 19.501 14.7778 19.5 13.9502 19.5H5.54981C4.72222 19.5 4.05639 19.501 3.51856 19.457C2.97195 19.4124 2.49205 19.3171 2.04785 19.0908C1.34225 18.7313 0.768706 18.1578 0.409181 17.4522C0.182866 17.008 0.0876302 16.5281 0.0429705 15.9814C-0.000968147 15.4436 1.65333e-06 14.7778 1.74489e-06 13.9502V5.54981C1.65225e-06 4.72222 -0.000968195 4.05639 0.0429705 3.51856C0.0876303 2.97195 0.182866 2.49205 0.409181 2.04785C0.768706 1.34225 1.34225 0.768706 2.04785 0.409181C2.49205 0.182866 2.97195 0.0876303 3.51856 0.0429705C4.05639 -0.000968207 4.72222 1.65211e-06 5.54981 1.74497e-06H13.9502ZM5.54981 1.5C4.69746 1.5 4.10322 1.50029 3.64063 1.53809C3.1868 1.57517 2.92602 1.64449 2.72852 1.74512C2.30515 1.96083 1.96083 2.30515 1.74512 2.72852C1.64449 2.92602 1.57517 3.1868 1.53809 3.64063C1.50029 4.10322 1.5 4.69746 1.5 5.54981V13.9502C1.5 14.8025 1.50029 15.3968 1.53809 15.8594C1.57517 16.3132 1.64449 16.574 1.74512 16.7715C1.96083 17.1949 2.30515 17.5392 2.72852 17.7549C2.92602 17.8555 3.1868 17.9248 3.64063 17.9619C4.10322 17.9997 4.69746 18 5.54981 18H13.9502C14.8025 18 15.3968 17.9997 15.8594 17.9619C16.3132 17.9248 16.574 17.8555 16.7715 17.7549C17.1949 17.5392 17.5392 17.1949 17.7549 16.7715C17.8555 16.574 17.9248 16.3132 17.9619 15.8594C17.9997 15.3968 18 14.8025 18 13.9502V5.54981C18 4.69746 17.9997 4.10322 17.9619 3.64063C17.9248 3.1868 17.8555 2.92602 17.7549 2.72852C17.5392 2.30515 17.1949 1.96083 16.7715 1.74512C16.574 1.64449 16.3132 1.57517 15.8594 1.53809C15.3968 1.50029 14.8025 1.5 13.9502 1.5H5.54981Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowSquareUpRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 2.25)">
        <path
          d="M12.75 6C13.1642 6 13.5 6.33581 13.5 6.75V12.75C13.5 13.1642 13.1642 13.5 12.75 13.5C12.3359 13.4999 12 13.1642 12 12.75V8.56055L7.28028 13.2803C6.98737 13.573 6.51258 13.5731 6.21973 13.2803C5.92694 12.9874 5.92698 12.5126 6.21973 12.2197L10.9395 7.5H6.75C6.33587 7.4999 6 7.16415 6 6.75C6.00003 6.33588 6.33589 6.0001 6.75 6H12.75Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9502 1.74497e-06C14.7778 1.65386e-06 15.4436 -0.000968084 15.9814 0.0429705C16.5281 0.0876302 17.008 0.182866 17.4522 0.409181C18.1578 0.768706 18.7313 1.34225 19.0908 2.04785C19.3171 2.49205 19.4124 2.97195 19.457 3.51856C19.501 4.05639 19.5 4.72222 19.5 5.54981V13.9502C19.5 14.7778 19.501 15.4436 19.457 15.9814C19.4124 16.5281 19.3171 17.008 19.0908 17.4522C18.7313 18.1578 18.1578 18.7313 17.4522 19.0908C17.008 19.3171 16.5281 19.4124 15.9814 19.457C15.4436 19.501 14.7778 19.5 13.9502 19.5H5.54981C4.72222 19.5 4.05639 19.501 3.51856 19.457C2.97195 19.4124 2.49205 19.3171 2.04785 19.0908C1.34225 18.7313 0.768706 18.1578 0.409181 17.4522C0.182866 17.008 0.0876302 16.5281 0.0429705 15.9814C-0.000968147 15.4436 1.65333e-06 14.7778 1.74489e-06 13.9502V5.54981C1.65225e-06 4.72222 -0.000968195 4.05639 0.0429705 3.51856C0.0876303 2.97195 0.182866 2.49205 0.409181 2.04785C0.768706 1.34225 1.34225 0.768706 2.04785 0.409181C2.49205 0.182866 2.97195 0.0876303 3.51856 0.0429705C4.05639 -0.000968207 4.72222 1.65211e-06 5.54981 1.74497e-06H13.9502ZM5.54981 1.5C4.69746 1.5 4.10322 1.50029 3.64063 1.53809C3.1868 1.57517 2.92602 1.64449 2.72852 1.74512C2.30515 1.96083 1.96083 2.30515 1.74512 2.72852C1.64449 2.92602 1.57517 3.1868 1.53809 3.64063C1.50029 4.10322 1.5 4.69746 1.5 5.54981V13.9502C1.5 14.8025 1.50029 15.3968 1.53809 15.8594C1.57517 16.3132 1.64449 16.574 1.74512 16.7715C1.96083 17.1949 2.30515 17.5392 2.72852 17.7549C2.92602 17.8555 3.1868 17.9248 3.64063 17.9619C4.10322 17.9997 4.69746 18 5.54981 18H13.9502C14.8025 18 15.3968 17.9997 15.8594 17.9619C16.3132 17.9248 16.574 17.8555 16.7715 17.7549C17.1949 17.5392 17.5392 17.1949 17.7549 16.7715C17.8555 16.574 17.9248 16.3132 17.9619 15.8594C17.9997 15.3968 18 14.8025 18 13.9502V5.54981C18 4.69746 17.9997 4.10322 17.9619 3.64063C17.9248 3.1868 17.8555 2.92602 17.7549 2.72852C17.5392 2.30515 17.1949 1.96083 16.7715 1.74512C16.574 1.64449 16.3132 1.57517 15.8594 1.53809C15.3968 1.50029 14.8025 1.5 13.9502 1.5H5.54981Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowsRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(3.25, 2.25)">
        <path
          d="M12.2197 10.2197C12.5126 9.92678 12.9874 9.92678 13.2803 10.2197L17.2803 14.2197C17.5731 14.5126 17.5732 14.9873 17.2803 15.2802L13.2803 19.2802C12.9874 19.5731 12.5126 19.5731 12.2197 19.2802C11.9268 18.9873 11.9269 18.5126 12.2197 18.2197L14.9395 15.4999H0.75C0.335805 15.4999 3.06649e-05 15.1641 0 14.7499C0 14.3357 0.335786 13.9999 0.75 13.9999H14.9395L12.2197 11.2802C11.9268 10.9873 11.9269 10.5126 12.2197 10.2197Z"
          fill="currentColor"
        />
        <path
          d="M7.21973 0.21967C7.51262 -0.0732233 7.98738 -0.0732233 8.28027 0.21967L12.2803 4.21967C12.5731 4.51257 12.5732 4.98733 12.2803 5.28022L8.28027 9.28022C7.98739 9.57307 7.51261 9.57307 7.21973 9.28022C6.92684 8.98733 6.92686 8.51257 7.21973 8.21967L9.93945 5.49994H0.75C0.335805 5.49994 3.07937e-05 5.16413 0 4.74994C0 4.33573 0.335786 3.99994 0.75 3.99994H9.93945L7.21973 1.28022C6.92684 0.987333 6.92686 0.512565 7.21973 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowStepsUpDownIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(8.43, 4.48)">
        <path
          d="M5.53308 9.51613C5.99372 9.51619 6.28214 10.0136 6.05359 10.4136L3.58777 14.729C3.35743 15.1321 2.77611 15.1321 2.54577 14.729L0.0799534 10.4136C-0.148557 10.0137 0.139972 9.51638 0.600461 9.51613H5.53308Z"
          fill="currentColor"
        />
        <path
          d="M2.54577 0.302259C2.77609 -0.100791 3.35738 -0.100714 3.58777 0.302259L6.05359 4.61769C6.28214 5.01766 5.99372 5.51607 5.53308 5.51613H0.600461C0.139972 5.51587 -0.148557 5.01758 0.0799534 4.61769L2.54577 0.302259Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowsTriangleIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.09)">
        <path
          d="M17.387 9.77453C17.7405 9.55862 18.2023 9.67014 18.4183 10.0236L19.4154 11.6554C19.8937 12.4381 20.2808 13.0691 20.5355 13.587C20.7879 14.1003 20.9712 14.6169 20.9241 15.1544C20.8553 15.94 20.4521 16.6587 19.8177 17.1271C19.3836 17.4473 18.8471 17.5602 18.2777 17.6124C17.7028 17.6651 16.9618 17.6642 16.0443 17.6642H13.0609L14.7806 19.3839C15.0735 19.6768 15.0735 20.1525 14.7806 20.4454C14.4877 20.7377 14.0128 20.7379 13.72 20.4454L10.72 17.4454C10.4273 17.1526 10.4275 16.6768 10.72 16.3839L13.72 13.3839C14.0129 13.0913 14.4878 13.0913 14.7806 13.3839C15.0735 13.6768 15.0735 14.1525 14.7806 14.4454L13.0618 16.1642H16.0443C16.9915 16.1642 17.6509 16.1642 18.1409 16.1193C18.6352 16.0739 18.8306 15.9903 18.9261 15.92C19.2145 15.7072 19.3977 15.3807 19.429 15.0236C19.4393 14.9055 19.4082 14.6954 19.1888 14.2491C18.9716 13.8076 18.629 13.2448 18.1351 12.4366L17.138 10.8058C16.9221 10.4525 17.0339 9.99062 17.387 9.77453Z"
          fill="currentColor"
        />
        <path
          d="M4.72981 7.67394C5.10489 7.61343 5.47212 7.84588 5.57258 8.22082L5.59113 8.29015C5.60024 8.3184 5.60788 8.34698 5.6136 8.37609L6.67121 12.3185C6.77824 12.7184 6.5408 13.1301 6.14094 13.2374C5.74113 13.3443 5.32938 13.1068 5.22199 12.7071L4.60578 10.4073L3.36555 12.4366C2.87176 13.2446 2.529 13.8076 2.31184 14.2491C2.09251 14.6952 2.06128 14.9056 2.0716 15.0236C2.10293 15.3807 2.28611 15.7071 2.57453 15.92C2.66985 15.9904 2.86499 16.0738 3.35969 16.1193C3.84971 16.1642 4.50911 16.1642 5.45637 16.1642H7.25031C7.66437 16.1642 8.00005 16.5002 8.00031 16.9142C8.00013 17.3282 7.66441 17.6642 7.25031 17.6642H5.45637C4.53876 17.6642 3.7978 17.6652 3.22297 17.6124C2.65345 17.5601 2.11702 17.4474 1.68293 17.1271C1.04853 16.6586 0.645317 15.94 0.576486 15.1544C0.529472 14.617 0.712802 14.1002 0.965158 13.587C1.21984 13.0692 1.60702 12.438 2.08528 11.6554L3.34504 9.59289L0.94465 10.2374C0.544832 10.3443 0.133072 10.1068 0.0257048 9.70715C-0.0814497 9.30724 0.15623 8.89565 0.555978 8.7882L4.65461 7.69055L4.72981 7.67394Z"
          fill="currentColor"
        />
        <path
          d="M9.65656 0.226678C10.3541 -0.075582 11.1465 -0.0755367 11.8441 0.226678C12.317 0.431705 12.6717 0.807742 12.9945 1.24133C13.3181 1.67612 13.6768 2.26542 14.1204 2.99133L15.3939 5.07531L16.0257 2.72082C16.1329 2.32079 16.5446 2.08349 16.9447 2.19055C17.3445 2.29783 17.5819 2.70861 17.4749 3.10851L16.3763 7.20715C16.2688 7.60674 15.8581 7.84441 15.4583 7.73742L11.3597 6.63879C10.9602 6.53137 10.7227 6.12049 10.8294 5.72082C10.9366 5.32079 11.3483 5.08349 11.7484 5.19055L14.0902 5.8175L12.8411 3.77355C12.3821 3.02248 12.0643 2.50354 11.7913 2.13683C11.5176 1.76915 11.3554 1.65051 11.2474 1.60363C10.9303 1.4663 10.5703 1.46625 10.2532 1.60363C10.1452 1.65063 9.98264 1.76961 9.7093 2.13683C9.4364 2.50352 9.11835 3.0227 8.65949 3.77355L7.63996 5.4425C7.42387 5.79563 6.96202 5.90743 6.60871 5.69152C6.25558 5.47555 6.14407 5.01359 6.35969 4.66027L7.3802 2.99133C7.8237 2.2656 8.18261 1.67609 8.50617 1.24133C8.82882 0.807865 9.18379 0.431744 9.65656 0.226678Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowsUpIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 3.25)">
        <path
          d="M4.2763 0.168031C4.57086 -0.0721909 5.00562 -0.0547575 5.2802 0.219789L9.2802 4.21979C9.57307 4.51265 9.57301 4.98744 9.2802 5.28034C8.98731 5.57323 8.51255 5.57323 8.21966 5.28034L5.49993 2.56061V16.7501C5.49993 17.1643 5.16412 17.5 4.74993 17.5001C4.33571 17.5001 3.99993 17.1643 3.99993 16.7501V2.56061L1.2802 5.28034C0.987308 5.57323 0.512548 5.57323 0.219655 5.28034C-0.0732083 4.98744 -0.0732283 4.51267 0.219655 4.21979L4.21966 0.219789L4.2763 0.168031Z"
          fill="currentColor"
        />
        <path
          d="M14.2763 5.16803C14.5709 4.92781 15.0056 4.94524 15.2802 5.21979L19.2802 9.21979C19.5731 9.51265 19.573 9.98744 19.2802 10.2803C18.9873 10.5732 18.5125 10.5732 18.2197 10.2803L15.4999 7.56061V16.7501C15.4999 17.1643 15.1641 17.5 14.7499 17.5001C14.3357 17.5001 13.9999 17.1643 13.9999 16.7501V7.56061L11.2802 10.2803C10.9873 10.5732 10.5125 10.5732 10.2197 10.2803C9.92679 9.98744 9.92677 9.51267 10.2197 9.21979L14.2197 5.21979L14.2763 5.16803Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowUpIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(4.25, 4.25)">
        <path
          d="M7.2763 0.168031C7.57086 -0.0721909 8.00562 -0.0547575 8.2802 0.219789L15.2802 7.21979C15.5731 7.51265 15.573 7.98744 15.2802 8.28034C14.9873 8.57323 14.5125 8.57323 14.2197 8.28034L8.49993 2.56061V14.7501C8.49993 15.1643 8.16412 15.5 7.74993 15.5001C7.33571 15.5001 6.99993 15.1643 6.99993 14.7501V2.56061L1.2802 8.28034C0.987308 8.57323 0.512548 8.57323 0.219655 8.28034C-0.0732083 7.98744 -0.0732283 7.51267 0.219655 7.21979L7.21966 0.219789L7.2763 0.168031Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowUpLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(6.25, 6.25)">
        <path
          d="M10.75 0C11.1642 0 11.5 0.335786 11.5 0.75C11.5 1.16421 11.1642 1.5 10.75 1.5H2.56055L11.2803 10.2197C11.5732 10.5126 11.5732 10.9874 11.2803 11.2803C10.9874 11.5732 10.5126 11.5732 10.2197 11.2803L1.5 2.56055V10.75C1.5 11.1642 1.16421 11.5 0.75 11.5C0.335786 11.5 0 11.1642 0 10.75V0.75C0 0.335786 0.335786 0 0.75 0H10.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ArrowUpRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(6, 6)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 2C0.447715 2 2.98023e-08 1.55228 2.98023e-08 1C2.98023e-08 0.447715 0.447715 0 1 0H11C11.5523 0 12 0.447715 12 1V11C12 11.5523 11.5523 12 11 12C10.4477 12 10 11.5523 10 11V3.41421L1.70711 11.7071C1.31658 12.0976 0.683418 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L8.58579 2H1Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ChevronDownDoubleIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(6.25, 5.25)">
        <path
          d="M10.2197 7.21967C10.5126 6.92678 10.9873 6.92678 11.2802 7.21967C11.5731 7.51257 11.5731 7.98734 11.2802 8.28022L6.28022 13.2802C5.98734 13.5731 5.51257 13.5731 5.21967 13.2802L0.21967 8.28022C-0.0732232 7.98732 -0.0732232 7.51256 0.21967 7.21967C0.512563 6.92678 0.987324 6.92678 1.28022 7.21967L5.74994 11.6894L10.2197 7.21967Z"
          fill="currentColor"
        />
        <path
          d="M10.2197 0.21967C10.5126 -0.0732233 10.9873 -0.0732233 11.2802 0.21967C11.5731 0.512568 11.5731 0.987342 11.2802 1.28022L6.28022 6.28022C5.98734 6.57309 5.51257 6.57305 5.21967 6.28022L0.21967 1.28022C-0.0732233 0.987324 -0.0732233 0.512563 0.21967 0.21967C0.512563 -0.0732233 0.987324 -0.0732233 1.28022 0.21967L5.74994 4.6894L10.2197 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ChevronDownIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(5.25, 8.25)">
        <path
          d="M12.2197 0.21967C12.5126 -0.0732233 12.9873 -0.0732233 13.2802 0.21967C13.5731 0.512568 13.5731 0.987342 13.2802 1.28022L7.28022 7.28022C6.98734 7.57309 6.51257 7.57305 6.21967 7.28022L0.21967 1.28022C-0.0732233 0.987324 -0.0732233 0.512563 0.21967 0.21967C0.512563 -0.0732233 0.987324 -0.0732233 1.28022 0.21967L6.74994 5.6894L12.2197 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ChevronLeftDoubleIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(5.25, 6.25)">
        <path
          d="M5.21967 0.21967C5.51256 -0.0732231 5.98732 -0.0732233 6.28022 0.21967C6.57305 0.512567 6.57309 0.987342 6.28022 1.28022L1.81049 5.74994L6.28022 10.2197C6.57305 10.5126 6.57309 10.9873 6.28022 11.2802C5.98734 11.5731 5.51257 11.5731 5.21967 11.2802L0.21967 6.28022C-0.0732233 5.98732 -0.0732233 5.51256 0.21967 5.21967L5.21967 0.21967Z"
          fill="currentColor"
        />
        <path
          d="M12.2197 0.21967C12.5126 -0.0732232 12.9873 -0.0732233 13.2802 0.21967C13.5731 0.512567 13.5731 0.987342 13.2802 1.28022L8.81049 5.74994L13.2802 10.2197C13.5731 10.5126 13.5731 10.9873 13.2802 11.2802C12.9873 11.5731 12.5126 11.5731 12.2197 11.2802L7.21967 6.28022C6.92678 5.98732 6.92678 5.51256 7.21967 5.21967L12.2197 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ChevronLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(8.25, 5.25)">
        <path
          d="M6.21967 0.21967C6.51256 -0.0732233 6.98732 -0.0732233 7.28022 0.21967C7.57305 0.512568 7.57309 0.987342 7.28022 1.28022L1.81049 6.74994L7.28022 12.2197C7.57305 12.5126 7.57309 12.9873 7.28022 13.2802C6.98734 13.5731 6.51257 13.5731 6.21967 13.2802L0.21967 7.28022C-0.0732233 6.98732 -0.0732232 6.51256 0.21967 6.21967L6.21967 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ChevronRightDoubleIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(5.25, 6.25)">
        <path
          d="M0.21967 0.21967C0.512563 -0.0732233 0.987324 -0.0732233 1.28022 0.21967L6.28022 5.21967C6.57305 5.51257 6.57309 5.98734 6.28022 6.28022L1.28022 11.2802C0.987342 11.5731 0.512568 11.5731 0.21967 11.2802C-0.0732233 10.9873 -0.0732233 10.5126 0.21967 10.2197L4.6894 5.74994L0.21967 1.28022C-0.0732233 0.987324 -0.0732233 0.512563 0.21967 0.21967Z"
          fill="currentColor"
        />
        <path
          d="M7.21967 0.21967C7.51256 -0.0732232 7.98732 -0.0732232 8.28022 0.21967L13.2802 5.21967C13.5731 5.51257 13.5731 5.98734 13.2802 6.28022L8.28022 11.2802C7.98734 11.5731 7.51257 11.5731 7.21967 11.2802C6.92678 10.9873 6.92678 10.5126 7.21967 10.2197L11.6894 5.74994L7.21967 1.28022C6.92678 0.987324 6.92678 0.512563 7.21967 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ChevronRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(8.25, 5.25)">
        <path
          d="M0.21967 0.21967C0.512563 -0.0732233 0.987324 -0.0732233 1.28022 0.21967L7.28022 6.21967C7.57305 6.51257 7.57309 6.98734 7.28022 7.28022L1.28022 13.2802C0.987342 13.5731 0.512568 13.5731 0.21967 13.2802C-0.0732233 12.9873 -0.0732233 12.5126 0.21967 12.2197L5.6894 6.74994L0.21967 1.28022C-0.0732233 0.987324 -0.0732233 0.512563 0.21967 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ChevronSelectorHorizontalIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(3.25, 6.25)">
        <path
          d="M5.21967 0.21967C5.51256 -0.0732233 5.98732 -0.0732233 6.28022 0.21967C6.57305 0.512568 6.57309 0.987342 6.28022 1.28022L1.81049 5.74994L6.28022 10.2197C6.57305 10.5126 6.57309 10.9873 6.28022 11.2802C5.98734 11.5731 5.51257 11.5731 5.21967 11.2802L0.21967 6.28022C-0.0732233 5.98732 -0.0732233 5.51256 0.21967 5.21967L5.21967 0.21967Z"
          fill="currentColor"
        />
        <path
          d="M11.2197 0.21967C11.5126 -0.0732233 11.9873 -0.0732231 12.2802 0.21967L17.2802 5.21967C17.5731 5.51257 17.5731 5.98734 17.2802 6.28022L12.2802 11.2802C11.9873 11.5731 11.5126 11.5731 11.2197 11.2802C10.9268 10.9873 10.9268 10.5126 11.2197 10.2197L15.6894 5.74994L11.2197 1.28022C10.9268 0.987324 10.9268 0.512563 11.2197 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ChevronSelectorVerticalIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(6.25, 3.25)">
        <path
          d="M10.2197 11.2198C10.5125 10.927 10.9873 10.927 11.2802 11.2198C11.5731 11.5127 11.573 11.9874 11.2802 12.2803L6.2802 17.2803C5.98731 17.5732 5.51255 17.5732 5.21965 17.2803L0.219655 12.2803C-0.0732082 11.9874 -0.0732283 11.5127 0.219655 11.2198C0.512545 10.927 0.987335 10.927 1.2802 11.2198L5.74993 15.6895L10.2197 11.2198Z"
          fill="currentColor"
        />
        <path
          d="M5.2763 0.168031C5.57086 -0.072191 6.00562 -0.0547574 6.2802 0.219789L11.2802 5.21979C11.5731 5.51265 11.573 5.98744 11.2802 6.28034C10.9873 6.57323 10.5125 6.57323 10.2197 6.28034L5.74993 1.81061L1.2802 6.28034C0.987308 6.57323 0.512548 6.57323 0.219655 6.28034C-0.0732081 5.98744 -0.0732283 5.51267 0.219655 5.21979L5.21965 0.219789L5.2763 0.168031Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ChevronUpDoubleIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(6.25, 5.25)">
        <path
          d="M5.2763 7.16803C5.57086 6.92781 6.00562 6.94524 6.2802 7.21979L11.2802 12.2198C11.5731 12.5127 11.573 12.9874 11.2802 13.2803C10.9873 13.5732 10.5125 13.5732 10.2197 13.2803L5.74993 8.81061L1.2802 13.2803C0.987309 13.5732 0.512548 13.5732 0.219655 13.2803C-0.0732082 12.9874 -0.0732283 12.5127 0.219655 12.2198L5.21965 7.21979L5.2763 7.16803Z"
          fill="currentColor"
        />
        <path
          d="M5.2763 0.168031C5.57086 -0.072191 6.00562 -0.0547574 6.2802 0.219789L11.2802 5.21979C11.5731 5.51265 11.573 5.98744 11.2802 6.28034C10.9873 6.57323 10.5125 6.57323 10.2197 6.28034L5.74993 1.81061L1.2802 6.28034C0.987308 6.57323 0.512548 6.57323 0.219655 6.28034C-0.0732081 5.98744 -0.0732283 5.51267 0.219655 5.21979L5.21965 0.219789L5.2763 0.168031Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ChevronUpIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(5.25, 8.25)">
        <path
          d="M6.2763 0.168031C6.57086 -0.0721908 7.00562 -0.0547575 7.2802 0.219789L13.2802 6.21979C13.5731 6.51265 13.573 6.98744 13.2802 7.28034C12.9873 7.57323 12.5125 7.57323 12.2197 7.28034L6.74993 1.81061L1.2802 7.28034C0.987308 7.57323 0.512548 7.57323 0.219655 7.28034C-0.0732081 6.98744 -0.0732283 6.51267 0.219655 6.21979L6.21965 0.219789L6.2763 0.168031Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CondenseIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 2.25)">
        <path
          d="M7.74994 10.9999C8.16413 11 8.49994 11.3357 8.49994 11.7499V17.7499C8.49991 18.1641 8.16411 18.4999 7.74994 18.4999C7.33575 18.4999 6.99997 18.1641 6.99994 17.7499V13.5605L1.28022 19.2802C0.987342 19.5731 0.512567 19.5731 0.21967 19.2802C-0.0732232 18.9873 -0.0732232 18.5126 0.21967 18.2197L5.9394 12.4999H1.74994C1.33575 12.4999 0.999974 12.1641 0.999943 11.7499C0.999943 11.3357 1.33573 10.9999 1.74994 10.9999H7.74994Z"
          fill="currentColor"
        />
        <path
          d="M18.2197 0.21967C18.5126 -0.0732232 18.9873 -0.0732232 19.2802 0.21967C19.5731 0.512567 19.5731 0.987342 19.2802 1.28022L13.5605 6.99994H17.7499C18.1641 6.99997 18.4999 7.33575 18.4999 7.74994C18.4999 8.16411 18.1641 8.49991 17.7499 8.49994H11.7499C11.3357 8.49994 11 8.16413 10.9999 7.74994V1.74994C10.9999 1.33573 11.3357 0.999943 11.7499 0.999943C12.1641 0.999974 12.4999 1.33575 12.4999 1.74994V5.9394L18.2197 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CornerDownLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(3.25, 3.25)">
        <path
          d="M16.7499 0C17.1641 3.06649e-05 17.4999 0.335805 17.4999 0.75V2.15039C17.4999 3.81798 17.5008 5.11429 17.416 6.15234C17.3304 7.19896 17.1543 8.04952 16.7646 8.81445C16.1175 10.0845 15.0845 11.1175 13.8144 11.7646C13.0495 12.1544 12.1989 12.3305 11.1523 12.416C10.1142 12.5008 8.8179 12.5 7.15033 12.5H2.56049L6.28022 16.2197C6.57307 16.5126 6.57307 16.9874 6.28022 17.2803C5.98733 17.5732 5.51257 17.5731 5.21967 17.2803L0.21967 12.2803C-0.0732233 11.9874 -0.0732233 11.5126 0.21967 11.2197L5.21967 6.21973C5.51257 5.92686 5.98733 5.92684 6.28022 6.21973C6.57307 6.51261 6.57307 6.98739 6.28022 7.28027L2.56049 11H7.15033C8.84239 11 10.0665 10.9995 11.0292 10.9209C11.9833 10.8429 12.6154 10.6919 13.1337 10.4277C14.1213 9.92444 14.9244 9.1214 15.4277 8.13379C15.6918 7.61541 15.8429 6.98341 15.9208 6.0293C15.9995 5.06655 15.9999 3.84247 15.9999 2.15039V0.75C15.9999 0.335786 16.3357 0 16.7499 0Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CornerDownRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(3.25, 3.25)">
        <path
          d="M0.75 0C1.16421 0 1.5 0.335786 1.5 0.75V2.15039C1.5 3.84247 1.50047 5.06655 1.5791 6.0293C1.65706 6.98343 1.80814 7.6154 2.07227 8.13379C2.57556 9.12141 3.37859 9.92444 4.36621 10.4277C4.8846 10.6919 5.51657 10.8429 6.4707 10.9209C7.43345 10.9995 8.65753 11 10.3496 11H14.9395L11.2197 7.28027C10.9268 6.98738 10.9268 6.51262 11.2197 6.21973C11.5126 5.92683 11.9874 5.92683 12.2803 6.21973L17.2803 11.2197C17.5732 11.5126 17.5732 11.9874 17.2803 12.2803L12.2803 17.2803C11.9874 17.5732 11.5126 17.5732 11.2197 17.2803C10.9268 16.9874 10.9268 16.5126 11.2197 16.2197L14.9395 12.5H10.3496C8.68202 12.5 7.38571 12.5008 6.34766 12.416C5.30103 12.3305 4.45049 12.1544 3.68555 11.7646C2.41545 11.1175 1.3825 10.0845 0.735352 8.81445C0.345624 8.04951 0.169528 7.19897 0.0839847 6.15234C-0.000827886 5.11429 2.18286e-07 3.81798 3.08922e-07 2.15039V0.75C3.08922e-07 0.335787 0.335787 1.28852e-07 0.75 0Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CornerLeftDownIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 3.25)">
        <path
          d="M18.7499 3.03978e-07C19.1641 3.09688e-05 19.4999 0.335806 19.4999 0.75C19.4999 1.16419 19.1641 1.49997 18.7499 1.5H15.3496C13.6575 1.5 12.4334 1.50048 11.4706 1.5791C10.5165 1.65706 9.88453 1.80815 9.36615 2.07227C8.37854 2.57556 7.5755 3.3786 7.07221 4.36621C6.80808 4.88459 6.657 5.51657 6.57904 6.4707C6.50041 7.43345 6.49994 8.65753 6.49994 10.3496V14.9395L10.2197 11.2197C10.5126 10.9269 10.9873 10.9268 11.2802 11.2197C11.5731 11.5126 11.5731 11.9874 11.2802 12.2803L6.28022 17.2803C6.13958 17.4209 5.94883 17.5 5.74994 17.5C5.55104 17.5 5.36032 17.4209 5.21967 17.2803L0.21967 12.2803C-0.0732233 11.9874 -0.0732233 11.5126 0.21967 11.2197C0.512565 10.9269 0.987333 10.9268 1.28022 11.2197L4.99994 14.9395V10.3496C4.99994 8.68202 4.99911 7.38571 5.08393 6.34766C5.16947 5.30103 5.34557 4.45049 5.73529 3.68555C6.38244 2.41546 7.4154 1.38249 8.68549 0.735352C9.45042 0.34564 10.301 0.169527 11.3476 0.0839847C12.3856 -0.000823312 13.682 2.13343e-07 15.3496 3.03978e-07H18.7499Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CornerLeftUpIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 3.25)">
        <path
          d="M5.74994 0C5.94883 1.52893e-05 6.13958 0.0790879 6.28022 0.219727L11.2802 5.21973C11.5731 5.51261 11.5731 5.98739 11.2802 6.28027C10.9873 6.57316 10.5126 6.57314 10.2197 6.28027L6.49994 2.56055V7.15039C6.49994 8.84247 6.50041 10.0665 6.57904 11.0293C6.657 11.9834 6.80808 12.6154 7.07221 13.1338C7.57551 14.1214 8.37854 14.9244 9.36615 15.4277C9.88453 15.6919 10.5165 15.8429 11.4706 15.9209C12.4334 15.9995 13.6575 16 15.3496 16H18.7499C19.1641 16 19.4999 16.3358 19.4999 16.75C19.4999 17.1642 19.1641 17.5 18.7499 17.5H15.3496C13.682 17.5 12.3856 17.5008 11.3476 17.416C10.301 17.3305 9.45042 17.1544 8.68549 16.7646C7.4154 16.1175 6.38244 15.0845 5.73529 13.8145C5.34557 13.0495 5.16947 12.199 5.08393 11.1523C4.99911 10.1143 4.99994 8.81798 4.99994 7.15039V2.56055L1.28022 6.28027C0.987333 6.57316 0.512565 6.57314 0.21967 6.28027C-0.0732233 5.98738 -0.0732233 5.51262 0.21967 5.21973L5.21967 0.219727L5.33393 0.125977C5.45622 0.0444634 5.6008 0 5.74994 0Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CornerRightDownIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 3.25)">
        <path
          d="M4.15039 3.08987e-07C5.81798 2.1835e-07 7.11429 -0.000827946 8.15234 0.0839847C9.19897 0.169528 10.0495 0.345624 10.8145 0.735352C12.0845 1.3825 13.1175 2.41545 13.7646 3.68555C14.1544 4.45049 14.3305 5.30103 14.416 6.34766C14.5008 7.38571 14.5 8.68202 14.5 10.3496V14.9395L18.2197 11.2197C18.5126 10.9268 18.9874 10.9268 19.2803 11.2197C19.5732 11.5126 19.5732 11.9874 19.2803 12.2803L14.2803 17.2803C14.1396 17.4209 13.9489 17.5 13.75 17.5C13.5511 17.5 13.3604 17.4209 13.2197 17.2803L8.21973 12.2803C7.92683 11.9874 7.92683 11.5126 8.21973 11.2197C8.51262 10.9268 8.98738 10.9268 9.28027 11.2197L13 14.9395V10.3496C13 8.65753 12.9995 7.43345 12.9209 6.4707C12.8429 5.51657 12.6919 4.8846 12.4277 4.36621C11.9244 3.37859 11.1214 2.57556 10.1338 2.07227C9.61541 1.80814 8.98343 1.65706 8.0293 1.5791C7.06655 1.50047 5.84247 1.5 4.15039 1.5H0.75C0.335786 1.5 0 1.16421 0 0.75C1.28851e-07 0.335787 0.335787 3.08987e-07 0.75 3.08987e-07H4.15039Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CornerRightUpIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 3.25)">
        <path
          d="M13.75 0C13.9489 0 14.1396 0.0790745 14.2803 0.219727L19.2803 5.21973C19.5732 5.51262 19.5732 5.98738 19.2803 6.28027C18.9874 6.57317 18.5126 6.57317 18.2197 6.28027L14.5 2.56055V7.15039C14.5 8.81798 14.5008 10.1143 14.416 11.1523C14.3305 12.199 14.1544 13.0495 13.7646 13.8145C13.1175 15.0845 12.0845 16.1175 10.8145 16.7646C10.0495 17.1544 9.19897 17.3305 8.15234 17.416C7.37377 17.4796 6.4497 17.4952 5.33301 17.499L0.75 17.5C0.335787 17.5 5.15403e-07 17.1642 0 16.75C0 16.3358 0.335786 16 0.75 16H4.15039C5.84247 16 7.06655 15.9995 8.0293 15.9209C8.98343 15.8429 9.61541 15.6919 10.1338 15.4277C11.1214 14.9244 11.9244 14.1214 12.4277 13.1338C12.6919 12.6154 12.8429 11.9834 12.9209 11.0293C12.9995 10.0665 13 8.84247 13 7.15039V2.56055L9.28027 6.28027C8.98738 6.57317 8.51262 6.57317 8.21973 6.28027C7.92683 5.98738 7.92683 5.51262 8.21973 5.21973L13.2197 0.219727L13.334 0.125977C13.4563 0.0444463 13.6008 1.89384e-07 13.75 0Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CornerUpLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(3.25, 3.25)">
        <path
          d="M5.21967 0.21967C5.51256 -0.0732233 5.98732 -0.0732233 6.28022 0.21967C6.57305 0.512568 6.57309 0.987342 6.28022 1.28022L2.56049 4.99994H7.15033C8.8179 4.99994 10.1142 4.99912 11.1523 5.08393C12.1989 5.16947 13.0495 5.34557 13.8144 5.73529C15.0845 6.38244 16.1175 7.41542 16.7646 8.68549C17.1543 9.45041 17.3304 10.301 17.416 11.3476C17.5008 12.3856 17.4999 13.682 17.4999 15.3496V16.7499C17.4999 17.1641 17.1641 17.4999 16.7499 17.4999C16.3357 17.4999 16 17.1641 15.9999 16.7499V15.3496C15.9999 13.6575 15.9995 12.4334 15.9208 11.4706C15.8429 10.5166 15.6918 9.88453 15.4277 9.36615C14.9244 8.37855 14.1213 7.57551 13.1337 7.07221C12.6154 6.80808 11.9833 6.657 11.0292 6.57904C10.0665 6.50042 8.84239 6.49994 7.15033 6.49994H2.56049L6.28022 10.2197C6.57305 10.5126 6.57309 10.9873 6.28022 11.2802C5.98734 11.5731 5.51257 11.5731 5.21967 11.2802L0.21967 6.28022C-0.0732233 5.98732 -0.0732233 5.51256 0.21967 5.21967L5.21967 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function CornerUpRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(3.25, 3.25)">
        <path
          d="M11.2197 0.21967C11.5126 -0.0732233 11.9874 -0.0732233 12.2803 0.21967L17.2803 5.21967C17.5731 5.51257 17.5732 5.98733 17.2803 6.28022L12.2803 11.2802C11.9874 11.5731 11.5126 11.5731 11.2197 11.2802C10.9268 10.9873 10.9269 10.5126 11.2197 10.2197L14.9395 6.49994H10.3496C8.65753 6.49994 7.43345 6.50041 6.4707 6.57904C5.51657 6.657 4.88459 6.80808 4.36621 7.07221C3.3786 7.5755 2.57556 8.37854 2.07227 9.36615C1.80815 9.88453 1.65706 10.5165 1.5791 11.4706C1.50048 12.4334 1.5 13.6575 1.5 15.3496V16.7499C1.49997 17.1641 1.16419 17.4999 0.75 17.4999C0.335806 17.4999 3.09688e-05 17.1641 3.03914e-07 16.7499V15.3496C2.13278e-07 13.682 -0.000823252 12.3856 0.0839847 11.3476C0.169527 10.301 0.34564 9.45042 0.735352 8.68549C1.38249 7.4154 2.41546 6.38244 3.68555 5.73529C4.45049 5.34557 5.30103 5.16947 6.34766 5.08393C7.38571 4.99912 8.68202 4.99994 10.3496 4.99994H14.9395L11.2197 1.28022C10.9268 0.987333 10.9269 0.512565 11.2197 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function Expand01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 2.25)">
        <path
          d="M7.21973 11.2197C7.51262 10.9268 7.98738 10.9268 8.28027 11.2197C8.57317 11.5126 8.57317 11.9874 8.28027 12.2803L2.56055 18H6.75C7.16421 18 7.5 18.3358 7.5 18.75C7.5 19.1642 7.16421 19.5 6.75 19.5H0.75C0.551088 19.5 0.360379 19.4209 0.219727 19.2803C0.0790745 19.1396 0 18.9489 0 18.75V12.75C0 12.3358 0.335787 12 0.75 12C1.16421 12 1.5 12.3358 1.5 12.75V16.9395L7.21973 11.2197Z"
          fill="currentColor"
        />
        <path
          d="M18.75 0C19.1642 0 19.5 0.335786 19.5 0.75V6.75C19.5 7.16421 19.1642 7.5 18.75 7.5C18.3358 7.5 18 7.16421 18 6.75V2.56055L12.2803 8.28027C11.9874 8.57317 11.5126 8.57317 11.2197 8.28027C10.9268 7.98738 10.9268 7.51262 11.2197 7.21973L16.9395 1.5H12.75C12.3358 1.5 12 1.16421 12 0.75C12 0.335786 12.3358 0 12.75 0H18.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function Expand02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 2.25)">
        <path
          d="M18.75 0C19.1642 0 19.5 0.335786 19.5 0.75V6.75C19.5 7.16421 19.1642 7.5 18.75 7.5C18.3358 7.5 18 7.16421 18 6.75V2.56055L2.56055 18H6.75C7.16421 18 7.5 18.3358 7.5 18.75C7.5 19.1642 7.16421 19.5 6.75 19.5H0.75C0.551088 19.5 0.360379 19.4209 0.219727 19.2803C0.0790745 19.1396 0 18.9489 0 18.75V12.75C0 12.3358 0.335787 12 0.75 12C1.16421 12 1.5 12.3358 1.5 12.75V16.9395L16.9395 1.5H12.75C12.3358 1.5 12 1.16421 12 0.75C12 0.335786 12.3358 0 12.75 0H18.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function Expand03Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 2.25)">
        <path
          d="M6.21973 12.2197C6.51262 11.9268 6.98738 11.9268 7.28028 12.2197C7.57317 12.5126 7.57317 12.9874 7.28028 13.2803L2.56055 18H6.75C7.16421 18 7.5 18.3358 7.5 18.75C7.5 19.1642 7.16422 19.5 6.75 19.5H0.750002C0.55109 19.5 0.36038 19.4209 0.219728 19.2803C0.0790773 19.1396 1.74497e-06 18.9489 1.74497e-06 18.75V12.75C2.64693e-06 12.3358 0.33579 12 0.750002 12C1.16421 12 1.5 12.3358 1.5 12.75V16.9395L6.21973 12.2197Z"
          fill="currentColor"
        />
        <path
          d="M18.75 11C19.1642 11 19.5 11.3358 19.5 11.75V13.9502C19.5 14.7778 19.501 15.4436 19.457 15.9814C19.4124 16.5281 19.3171 17.008 19.0908 17.4522C18.7313 18.1578 18.1578 18.7313 17.4522 19.0908C17.008 19.3171 16.5281 19.4124 15.9814 19.457C15.4436 19.501 14.7778 19.5 13.9502 19.5H11.75C11.3358 19.5 11 19.1642 11 18.75C11 18.3358 11.3358 18 11.75 18H13.9502C14.8025 18 15.3968 17.9997 15.8594 17.9619C16.3132 17.9248 16.574 17.8555 16.7715 17.7549C17.1949 17.5392 17.5392 17.1949 17.7549 16.7715C17.8555 16.574 17.9248 16.3132 17.9619 15.8594C17.9997 15.3968 18 14.8025 18 13.9502V11.75C18 11.3358 18.3358 11 18.75 11Z"
          fill="currentColor"
        />
        <path
          d="M7.75 1.74497e-06C8.16421 1.74497e-06 8.5 0.335789 8.5 0.750002C8.5 1.16422 8.16422 1.5 7.75 1.5H5.54981C4.69746 1.5 4.10322 1.50029 3.64063 1.53809C3.1868 1.57517 2.92602 1.64449 2.72852 1.74512C2.30515 1.96083 1.96083 2.30515 1.74512 2.72852C1.64449 2.92602 1.57517 3.1868 1.53809 3.64063C1.50029 4.10322 1.5 4.69746 1.5 5.54981V7.75C1.5 8.16422 1.16422 8.5 0.750002 8.5C0.335789 8.5 1.74497e-06 8.16421 1.74497e-06 7.75V5.54981C1.65211e-06 4.72222 -0.000968207 4.05639 0.0429705 3.51856C0.0876303 2.97195 0.182866 2.49205 0.409181 2.04785C0.768707 1.34225 1.34225 0.768707 2.04785 0.409181C2.49205 0.182866 2.97195 0.0876303 3.51856 0.0429705C4.05639 -0.000968207 4.72222 1.65211e-06 5.54981 1.74497e-06H7.75Z"
          fill="currentColor"
        />
        <path
          d="M18.75 1.74497e-06C19.1642 1.74497e-06 19.5 0.335789 19.5 0.750002V6.75C19.5 7.16422 19.1642 7.5 18.75 7.5C18.3358 7.5 18 7.16421 18 6.75V2.56055L13.2803 7.28028C12.9874 7.57317 12.5126 7.57317 12.2197 7.28028C11.9268 6.98738 11.9268 6.51262 12.2197 6.21973L16.9395 1.5H12.75C12.3358 1.5 12 1.16421 12 0.750002C12 0.335789 12.3358 2.64693e-06 12.75 1.74497e-06H18.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function Expand04Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 2.25)">
        <path
          d="M6.21973 12.2197C6.51262 11.9268 6.98738 11.9268 7.28027 12.2197C7.57317 12.5126 7.57317 12.9874 7.28027 13.2803L2.56055 18H6.75C7.16421 18 7.5 18.3358 7.5 18.75C7.5 19.1642 7.16421 19.5 6.75 19.5H0.75C0.551088 19.5 0.360379 19.4209 0.219727 19.2803C0.0790745 19.1396 0 18.9489 0 18.75V12.75C0 12.3358 0.335787 12 0.75 12C1.16421 12 1.5 12.3358 1.5 12.75V16.9395L6.21973 12.2197Z"
          fill="currentColor"
        />
        <path
          d="M17.75 11C18.1642 11 18.5 11.3358 18.5 11.75V14.5498C18.5 15.0975 18.501 15.5537 18.4707 15.9248C18.4397 16.3045 18.3719 16.6609 18.2002 16.998C17.9365 17.5155 17.5155 17.9365 16.998 18.2002C16.6609 18.3719 16.3045 18.4397 15.9248 18.4707C15.5537 18.501 15.0975 18.5 14.5498 18.5H11.75C11.3358 18.5 11 18.1642 11 17.75C11 17.3358 11.3358 17 11.75 17H14.5498C15.1222 17 15.5069 16.9998 15.8027 16.9756C16.0897 16.9521 16.2268 16.9094 16.3174 16.8633C16.5525 16.7435 16.7435 16.5525 16.8633 16.3174C16.9094 16.2268 16.9521 16.0897 16.9756 15.8027C16.9998 15.5069 17 15.1222 17 14.5498V11.75C17 11.3358 17.3358 11 17.75 11Z"
          fill="currentColor"
        />
        <path
          d="M7.75 1C8.16421 1 8.5 1.33579 8.5 1.75C8.5 2.16421 8.16421 2.5 7.75 2.5H4.9502C4.37777 2.5 3.99314 2.50024 3.69727 2.52441C3.41027 2.54788 3.27316 2.59059 3.18262 2.63672C2.9475 2.75655 2.75655 2.9475 2.63672 3.18262C2.59059 3.27316 2.54788 3.41027 2.52441 3.69727C2.50024 3.99314 2.5 4.37777 2.5 4.9502V7.75C2.5 8.16421 2.16421 8.5 1.75 8.5C1.33579 8.5 1 8.16421 1 7.75V4.9502C1 4.40252 0.998974 3.94632 1.0293 3.5752C1.06033 3.19546 1.12809 2.8391 1.2998 2.50195C1.56346 1.98451 1.98451 1.56346 2.50195 1.2998C2.8391 1.12809 3.19546 1.06033 3.5752 1.0293C3.94632 0.998974 4.40252 1 4.9502 1H7.75Z"
          fill="currentColor"
        />
        <path
          d="M18.75 0C19.1642 0 19.5 0.335786 19.5 0.75V6.75C19.5 7.16421 19.1642 7.5 18.75 7.5C18.3358 7.5 18 7.16421 18 6.75V2.56055L13.2803 7.28027C12.9874 7.57317 12.5126 7.57317 12.2197 7.28027C11.9268 6.98738 11.9268 6.51262 12.2197 6.21973L16.9395 1.5H12.75C12.3358 1.5 12 1.16421 12 0.75C12 0.335786 12.3358 0 12.75 0H18.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function Expand05Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 2.25)">
        <path
          d="M6.21973 12.2197C6.51262 11.9268 6.98738 11.9268 7.28027 12.2197C7.57317 12.5126 7.57317 12.9874 7.28027 13.2803L2.56055 18H6.75C7.16421 18 7.5 18.3358 7.5 18.75C7.5 19.1642 7.16421 19.5 6.75 19.5H0.75C0.551088 19.5 0.360379 19.4209 0.219727 19.2803C0.0790746 19.1396 0 18.9489 0 18.75V12.75C0 12.3358 0.335787 12 0.75 12C1.16421 12 1.5 12.3358 1.5 12.75V16.9395L6.21973 12.2197Z"
          fill="currentColor"
        />
        <path
          d="M18.75 12C19.1642 12 19.5 12.3358 19.5 12.75V18.75C19.5 19.1642 19.1642 19.5 18.75 19.5H12.75C12.3358 19.5 12 19.1642 12 18.75C12 18.3358 12.3358 18 12.75 18H16.9395L12.2197 13.2803C11.9268 12.9874 11.9268 12.5126 12.2197 12.2197C12.5126 11.9268 12.9874 11.9268 13.2803 12.2197L18 16.9395V12.75C18 12.3358 18.3358 12 18.75 12Z"
          fill="currentColor"
        />
        <path
          d="M6.75 0C7.16421 -5.96046e-08 7.5 0.335786 7.5 0.75C7.5 1.16421 7.16421 1.5 6.75 1.5H2.56055L7.28027 6.21973C7.57317 6.51262 7.57317 6.98738 7.28027 7.28027C6.98738 7.57317 6.51262 7.57317 6.21973 7.28027L1.5 2.56055V6.75C1.5 7.16421 1.16421 7.5 0.75 7.5C0.335787 7.5 5.96046e-08 7.16421 0 6.75V0.75C2.75422e-07 0.335787 0.335787 5.96046e-08 0.75 0H6.75Z"
          fill="currentColor"
        />
        <path
          d="M18.75 0C19.1642 0 19.5 0.335787 19.5 0.75V6.75C19.5 7.16421 19.1642 7.5 18.75 7.5C18.3358 7.5 18 7.16421 18 6.75V2.56055L13.2803 7.28027C12.9874 7.57317 12.5126 7.57317 12.2197 7.28027C11.9268 6.98738 11.9268 6.51262 12.2197 6.21973L16.9395 1.5H12.75C12.3358 1.5 12 1.16421 12 0.75C12 0.335787 12.3358 0 12.75 0H18.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function Expand06Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 2.25)">
        <path
          d="M5.21973 13.2197C5.51262 12.9268 5.98738 12.9268 6.28027 13.2197C6.57317 13.5126 6.57317 13.9874 6.28027 14.2803L2.56055 18H5.75C6.16421 18 6.5 18.3358 6.5 18.75C6.5 19.1642 6.16421 19.5 5.75 19.5H0.75C0.551088 19.5 0.360379 19.4209 0.219727 19.2803C0.0790746 19.1396 0 18.9489 0 18.75V13.75C5.96046e-08 13.3358 0.335787 13 0.75 13C1.16421 13 1.5 13.3358 1.5 13.75V16.9395L5.21973 13.2197Z"
          fill="currentColor"
        />
        <path
          d="M18.75 13C19.1642 13 19.5 13.3358 19.5 13.75V18.75C19.5 19.1642 19.1642 19.5 18.75 19.5H13.75C13.3358 19.5 13 19.1642 13 18.75C13 18.3358 13.3358 18 13.75 18H16.9395L13.2197 14.2803C12.9268 13.9874 12.9268 13.5126 13.2197 13.2197C13.5126 12.9268 13.9874 12.9268 14.2803 13.2197L18 16.9395V13.75C18 13.3358 18.3358 13 18.75 13Z"
          fill="currentColor"
        />
        <path
          d="M5.75 0C6.16421 -5.96046e-08 6.5 0.335786 6.5 0.75C6.5 1.16421 6.16421 1.5 5.75 1.5H2.56055L6.28027 5.21973C6.57317 5.51262 6.57317 5.98738 6.28027 6.28027C5.98738 6.57317 5.51262 6.57317 5.21973 6.28027L1.5 2.56055V5.75C1.5 6.16421 1.16421 6.5 0.75 6.5C0.335787 6.5 0 6.16421 0 5.75V0.75C2.75422e-07 0.335787 0.335787 5.96046e-08 0.75 0H5.75Z"
          fill="currentColor"
        />
        <path
          d="M18.75 0C19.1642 0 19.5 0.335787 19.5 0.75V5.75C19.5 6.16421 19.1642 6.5 18.75 6.5C18.3358 6.5 18 6.16421 18 5.75V2.56055L14.2803 6.28027C13.9874 6.57317 13.5126 6.57317 13.2197 6.28027C12.9268 5.98738 12.9268 5.51262 13.2197 5.21973L16.9395 1.5H13.75C13.3358 1.5 13 1.16421 13 0.75C13 0.335787 13.3358 0 13.75 0H18.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function FlipBackwardIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 4.25)">
        <path
          d="M4.21967 0.21967C4.51256 -0.0732233 4.98732 -0.0732233 5.28022 0.21967C5.57305 0.512568 5.57309 0.987342 5.28022 1.28022L2.56049 3.99994H14.2499C17.1494 3.99997 19.4999 6.35047 19.4999 9.24994C19.4999 12.1494 17.1494 14.4999 14.2499 14.4999H9.74994C9.33575 14.4999 8.99997 14.1641 8.99994 13.7499C8.99994 13.3357 9.33573 12.9999 9.74994 12.9999H14.2499C16.321 12.9999 17.9999 11.321 17.9999 9.24994C17.9999 7.17889 16.321 5.49997 14.2499 5.49994H2.56049L5.28022 8.21967C5.57305 8.51257 5.57309 8.98734 5.28022 9.28022C4.98734 9.57309 4.51257 9.57305 4.21967 9.28022L0.21967 5.28022C-0.0732233 4.98732 -0.0732233 4.51256 0.21967 4.21967L4.21967 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function FlipForwardIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 4.25)">
        <path
          d="M14.2197 0.21967C14.5126 -0.0732233 14.9874 -0.0732233 15.2803 0.21967L19.2803 4.21967C19.5731 4.51257 19.5732 4.98733 19.2803 5.28022L15.2803 9.28022C14.9874 9.57307 14.5126 9.57307 14.2197 9.28022C13.9268 8.98733 13.9269 8.51257 14.2197 8.21967L16.9395 5.49994H5.25C3.17893 5.49994 1.5 7.17888 1.5 9.24994C1.50003 11.321 3.17895 12.9999 5.25 12.9999H9.75C10.1642 12.9999 10.5 13.3357 10.5 13.7499C10.5 14.1641 10.1642 14.4999 9.75 14.4999H5.25C2.35052 14.4999 3.04095e-05 12.1494 0 9.24994C0 6.35045 2.3505 3.99994 5.25 3.99994H16.9395L14.2197 1.28022C13.9268 0.987333 13.9269 0.512565 14.2197 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function HeightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 2.25)">
        <path
          d="M9.75 11C10.1642 11 10.5 11.3358 10.5 11.75V13.9395L11.2197 13.2197C11.5126 12.9268 11.9874 12.9268 12.2803 13.2197C12.5732 13.5126 12.5732 13.9874 12.2803 14.2803L10.2803 16.2803C10.2317 16.3289 10.1761 16.366 10.1191 16.3984C10.092 16.4139 10.0653 16.4303 10.0361 16.4424C10.0041 16.4556 9.97077 16.4641 9.9375 16.4727C9.92438 16.4761 9.91183 16.4817 9.89844 16.4844C9.89292 16.4855 9.88737 16.4863 9.88184 16.4873C9.83898 16.4949 9.79505 16.5 9.75 16.5C9.70462 16.5 9.66035 16.495 9.61719 16.4873C9.61166 16.4863 9.6061 16.4855 9.60059 16.4844C9.5872 16.4817 9.57464 16.4761 9.56153 16.4727C9.52828 16.464 9.49493 16.4557 9.46289 16.4424C9.43375 16.4303 9.40703 16.414 9.37988 16.3984C9.32321 16.366 9.26812 16.3287 9.21973 16.2803L7.21973 14.2803C6.92684 13.9874 6.92684 13.5126 7.21973 13.2197C7.51262 12.9268 7.98738 12.9268 8.28028 13.2197L9 13.9395V11.75C9 11.3358 9.33579 11 9.75 11Z"
          fill="currentColor"
        />
        <path
          d="M9.75 3C9.79499 3 9.83903 3.00413 9.88184 3.01172C9.88737 3.0127 9.89293 3.01354 9.89844 3.01465C9.91182 3.01734 9.92439 3.02298 9.9375 3.02637C9.97073 3.03495 10.0041 3.04344 10.0361 3.05664C10.0653 3.06868 10.092 3.08512 10.1191 3.10059C10.1763 3.1331 10.2316 3.17101 10.2803 3.21973L12.2803 5.21973C12.5732 5.51262 12.5732 5.98738 12.2803 6.28028C11.9874 6.57317 11.5126 6.57317 11.2197 6.28028L10.5 5.56055V7.75C10.5 8.16422 10.1642 8.5 9.75 8.5C9.33579 8.5 9 8.16421 9 7.75V5.56055L8.28028 6.28028C7.98738 6.57317 7.51262 6.57317 7.21973 6.28028C6.92684 5.98738 6.92684 5.51262 7.21973 5.21973L9.21973 3.21973C9.26824 3.17122 9.32305 3.13303 9.37988 3.10059C9.4055 3.08596 9.43062 3.07018 9.45801 3.0586L9.46778 3.05469C9.49823 3.04234 9.53 3.03455 9.56153 3.02637C9.57463 3.02297 9.58722 3.01735 9.60059 3.01465C9.6061 3.01354 9.61166 3.01271 9.61719 3.01172C9.6603 3.00402 9.70468 3 9.75 3Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9502 1.74497e-06C14.7778 1.65386e-06 15.4436 -0.000968084 15.9814 0.0429705C16.5281 0.0876302 17.008 0.182866 17.4522 0.409181C18.1578 0.768706 18.7313 1.34225 19.0908 2.04785C19.3171 2.49205 19.4124 2.97195 19.457 3.51856C19.501 4.05639 19.5 4.72222 19.5 5.54981V13.9502C19.5 14.7778 19.501 15.4436 19.457 15.9814C19.4124 16.5281 19.3171 17.008 19.0908 17.4522C18.7313 18.1578 18.1578 18.7313 17.4522 19.0908C17.008 19.3171 16.5281 19.4124 15.9814 19.457C15.4436 19.501 14.7778 19.5 13.9502 19.5H5.54981C4.72222 19.5 4.05639 19.501 3.51856 19.457C2.97195 19.4124 2.49205 19.3171 2.04785 19.0908C1.34225 18.7313 0.768706 18.1578 0.409181 17.4522C0.182866 17.008 0.0876302 16.5281 0.0429705 15.9814C-0.000968147 15.4436 1.65333e-06 14.7778 1.74489e-06 13.9502V5.54981C1.65225e-06 4.72222 -0.000968195 4.05639 0.0429705 3.51856C0.0876303 2.97195 0.182866 2.49205 0.409181 2.04785C0.768706 1.34225 1.34225 0.768706 2.04785 0.409181C2.49205 0.182866 2.97195 0.0876303 3.51856 0.0429705C4.05639 -0.000968207 4.72222 1.65211e-06 5.54981 1.74497e-06H13.9502ZM5.54981 1.5C4.69746 1.5 4.10322 1.50029 3.64063 1.53809C3.1868 1.57517 2.92602 1.64449 2.72852 1.74512C2.30515 1.96083 1.96083 2.30515 1.74512 2.72852C1.64449 2.92602 1.57517 3.1868 1.53809 3.64063C1.50029 4.10322 1.5 4.69746 1.5 5.54981V13.9502C1.5 14.8025 1.50029 15.3968 1.53809 15.8594C1.57517 16.3132 1.64449 16.574 1.74512 16.7715C1.96083 17.1949 2.30515 17.5392 2.72852 17.7549C2.92602 17.8555 3.1868 17.9248 3.64063 17.9619C4.10322 17.9997 4.69746 18 5.54981 18H13.9502C14.8025 18 15.3968 17.9997 15.8594 17.9619C16.3132 17.9248 16.574 17.8555 16.7715 17.7549C17.1949 17.5392 17.5392 17.1949 17.7549 16.7715C17.8555 16.574 17.9248 16.3132 17.9619 15.8594C17.9997 15.3968 18 14.8025 18 13.9502V5.54981C18 4.69746 17.9997 4.10322 17.9619 3.64063C17.9248 3.1868 17.8555 2.92602 17.7549 2.72852C17.5392 2.30515 17.1949 1.96083 16.7715 1.74512C16.574 1.64449 16.3132 1.57517 15.8594 1.53809C15.3968 1.50029 14.8025 1.5 13.9502 1.5H5.54981Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function InfinityIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 7.25)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.9287 0.000976562C18.418 0.00123182 19.5841 0.593755 20.3662 1.51465C21.1346 2.41945 21.5 3.59927 21.5 4.75C21.5 5.90073 21.1346 7.08055 20.3662 7.98535C19.5839 8.90644 18.4175 9.5 16.9277 9.5C15.4397 9.5 14.2021 8.9104 13.125 8.09863C12.2751 7.45811 11.4921 6.65166 10.7471 5.85059C9.05856 7.64533 7.05174 9.5 4.18848 9.5C2.79588 9.49992 1.72069 8.8803 1.01367 7.95508C0.322593 7.05059 0 5.88187 0 4.75C0 3.61813 0.322593 2.44941 1.01367 1.54492C1.72069 0.619703 2.79588 8.10665e-05 4.18848 0C7.05174 0 9.05962 1.85368 10.748 3.64844C11.4928 2.84775 12.2754 2.04161 13.125 1.40137C14.2018 0.589958 15.4394 0.0015025 16.9268 0.000976562L16.9277 0L16.9287 0.000976562ZM4.18848 1.5C3.28906 1.50008 2.64519 1.88064 2.20605 2.45508C1.75101 3.05056 1.5 3.88197 1.5 4.75C1.5 5.61803 1.75101 6.44944 2.20605 7.04492C2.64519 7.61936 3.28906 7.99992 4.18848 8C6.40816 8 8.01534 6.56281 9.72168 4.75C8.01543 2.93718 6.40818 1.5 4.18848 1.5ZM16.9277 1.5C15.8686 1.50026 14.9412 1.9108 14.0283 2.59863C13.2559 3.18073 12.5325 3.93025 11.7715 4.75C12.5324 5.56974 13.255 6.31928 14.0273 6.90137C14.9405 7.58959 15.8683 8 16.9277 8C17.9859 8 18.731 7.59352 19.2227 7.01465C19.7281 6.41949 20 5.59916 20 4.75C20 3.90084 19.7281 3.08051 19.2227 2.48535C18.731 1.90648 17.9859 1.5 16.9277 1.5Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function RefreshCcw01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M10.75 0C16.1348 0 20.5 4.36522 20.5 9.75C20.5 15.1348 16.1348 19.5 10.75 19.5C6.30389 19.5 2.55435 16.5247 1.38086 12.458C1.26605 12.0601 1.49572 11.6442 1.89355 11.5293C2.2915 11.4145 2.70739 11.6441 2.82227 12.042C3.81546 15.4839 6.98992 18 10.75 18C15.3063 18 19 14.3063 19 9.75C19 5.19365 15.3063 1.5 10.75 1.5C8.47063 1.5 6.408 2.42304 4.91406 3.91797C4.13064 4.70193 3.24357 5.76611 2.54297 6.64746C2.44637 6.76899 2.35468 6.88748 2.2666 7H6.75C7.16421 7 7.5 7.33579 7.5 7.75C7.5 8.16421 7.16421 8.5 6.75 8.5H0.75C0.335786 8.5 0 8.16421 0 7.75V1.75C0 1.33579 0.335786 1 0.75 1C1.16421 1 1.5 1.33579 1.5 1.75V5.55078C2.19034 4.68864 3.05898 3.65349 3.85352 2.8584C5.61728 1.09342 8.0566 0 10.75 0Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function RefreshCcw02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M20.75 11.0001C21.1641 11.0001 21.4999 11.336 21.5 11.7501V17.7501C21.5 18.1643 21.1642 18.5001 20.75 18.5001C20.3358 18.5001 20 18.1643 20 17.7501V14.13C19.4523 14.7707 18.6951 15.594 17.6445 16.6447C13.8369 20.4523 7.66308 20.4523 3.85547 16.6447C2.5073 15.2964 1.63543 13.6493 1.24219 11.9161C1.1507 11.5123 1.40389 11.1104 1.80762 11.0187C2.21144 10.9271 2.61329 11.1804 2.70508 11.5841C3.03754 13.0494 3.77377 14.4418 4.91602 15.5841C8.13784 18.8059 13.3622 18.8059 16.584 15.5841C18.0488 14.1193 18.9018 13.1361 19.3965 12.5001H14.75C14.3358 12.5001 14 12.1643 14 11.7501C14.0001 11.336 14.3359 11.0001 14.75 11.0001H20.75Z"
          fill="currentColor"
        />
        <path
          d="M3.85547 2.85559C7.66305 -0.951863 13.8369 -0.951863 17.6445 2.85559C18.9927 4.20376 19.8645 5.85097 20.2578 7.5841C20.3494 7.98795 20.0962 8.38979 19.6924 8.48157C19.2885 8.57321 18.8866 8.32003 18.7949 7.91614C18.4624 6.45088 17.7262 5.05839 16.584 3.91614C13.3622 0.69447 8.13781 0.69447 4.91602 3.91614C3.45123 5.38092 2.5982 6.36408 2.10352 7.00012H6.75C7.16413 7.00012 7.49987 7.33602 7.5 7.75012C7.5 8.16433 7.16421 8.50012 6.75 8.50012H0.75C0.335786 8.50012 0 8.16433 0 7.75012V1.75012C0.000130109 1.33602 0.335867 1.00012 0.75 1.00012C1.16413 1.00012 1.49987 1.33602 1.5 1.75012V5.36926C2.04771 4.72866 2.80518 3.90587 3.85547 2.85559Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function RefreshCcw03Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 1.25)">
        <path
          d="M7.58408 1.24219C7.988 1.15054 8.38985 1.40373 8.48154 1.80762C8.57319 2.21155 8.32003 2.6134 7.91611 2.70508C6.45083 3.03757 5.05838 3.77375 3.91611 4.91602C0.694641 8.13769 0.694836 13.3612 3.91611 16.583C5.38099 18.0479 6.36406 18.9018 7.0001 19.3965V14.75C7.0001 14.3358 7.33597 14.0001 7.7501 14C8.16431 14 8.5001 14.3358 8.5001 14.75V20.75C8.49999 21.1641 8.16424 21.5 7.7501 21.5H1.7501C1.33598 21.4999 1.00011 21.1641 1.0001 20.75C1.0001 20.3359 1.33598 20.0001 1.7501 20H5.37021C4.72953 19.4523 3.90618 18.6951 2.85556 17.6445C-0.951887 13.837 -0.951822 7.66306 2.85556 3.85547C4.20374 2.50729 5.85095 1.63547 7.58408 1.24219Z"
          fill="currentColor"
        />
        <path
          d="M17.7501 0C18.1643 0 18.5001 0.335786 18.5001 0.75C18.5001 1.16421 18.1643 1.5 17.7501 1.5H14.13C14.7707 2.04774 15.594 2.80485 16.6446 3.85547C20.4522 7.66308 20.4522 13.8369 16.6446 17.6445C15.2964 18.9927 13.6493 19.8646 11.9161 20.2578C11.5123 20.3493 11.1104 20.0961 11.0187 19.6924C10.927 19.2885 11.1803 18.8867 11.5841 18.7949C13.0494 18.4625 14.4418 17.7262 15.5841 16.584C18.8059 13.3622 18.8059 8.13784 15.5841 4.91602C14.1189 3.45081 13.1361 2.59714 12.5001 2.10254V6.75C12.5001 7.16421 12.1643 7.5 11.7501 7.5C11.336 7.4999 11.0001 7.16415 11.0001 6.75V0.75C11.0001 0.551133 11.0792 0.36037 11.2198 0.219727C11.3604 0.0791193 11.5513 5.06579e-05 11.7501 0H17.7501Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function RefreshCcw04Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.75, 0.85)">
        <path
          d="M3.80859 3.66867C4.14325 3.42526 4.61259 3.49933 4.85645 3.83371C5.10007 4.16841 5.02592 4.63768 4.69141 4.88156C2.75576 6.29194 1.50014 8.57474 1.5 11.1501C1.5002 15.1781 4.57343 18.4871 8.50293 18.863L7.71973 18.0798C7.42715 17.7869 7.42694 17.312 7.71973 17.0193C8.01254 16.7268 8.48746 16.7268 8.78027 17.0193L10.7803 19.0193C11.0731 19.312 11.0729 19.7869 10.7803 20.0798L8.78027 22.0798C8.48738 22.3727 8.01262 22.3727 7.71973 22.0798C7.42715 21.7869 7.42694 21.312 7.71973 21.0193L8.38086 20.3571C3.68004 19.919 0.000199182 15.9654 0 11.1501C0.000140523 8.0749 1.50195 5.34922 3.80859 3.66867Z"
          fill="currentColor"
        />
        <path
          d="M9.71973 0.219454C10.0126 -0.0731514 10.4874 -0.0731514 10.7803 0.219454C11.0731 0.512275 11.073 0.987091 10.7803 1.28L10.1182 1.94113C14.8195 2.37881 18.4998 6.33448 18.5 11.1501C18.4999 14.2253 16.9979 16.95 14.6914 18.6306C14.3566 18.8743 13.8874 18.8003 13.6436 18.4655C13.4002 18.1308 13.474 17.6614 13.8086 17.4177C15.7441 16.0073 16.9999 13.7254 17 11.1501C16.9998 7.12215 13.9266 3.81214 9.99707 3.43625L10.7803 4.21945C11.0731 4.51228 11.073 4.98709 10.7803 5.28C10.4874 5.57289 10.0126 5.57289 9.71973 5.28L7.71973 3.28C7.42705 2.98709 7.42691 2.51228 7.71973 2.21945L9.71973 0.219454Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function RefreshCcw05Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.74, 2.75)">
        <path
          d="M17.2259 3.46071L19.9573 4.19215C20.3574 4.29934 20.5947 4.71107 20.4876 5.1111C20.3803 5.51103 19.9696 5.74848 19.5696 5.64137L18.6653 5.39918C20.6369 9.68953 19.0526 14.8536 14.8821 17.2615C12.2188 18.7991 9.10811 18.8612 6.49933 17.7039C6.12126 17.5357 5.9499 17.0929 6.11749 16.7146C6.28544 16.3363 6.72927 16.1652 7.10773 16.3328C9.2971 17.3041 11.9016 17.2504 14.1321 15.9627C17.6208 13.9484 18.9497 9.63204 17.3099 6.04078L17.0237 7.1111C16.9165 7.51099 16.5057 7.74834 16.1058 7.64137C15.706 7.53395 15.4683 7.12235 15.5755 6.72242L16.3069 3.99098L16.3304 3.91774C16.4653 3.56253 16.851 3.36052 17.2259 3.46071Z"
          fill="currentColor"
        />
        <path
          d="M5.63116 1.24C8.29431 -0.297563 11.4053 -0.358489 14.014 0.798597C14.3925 0.96654 14.5636 1.40928 14.3958 1.78785C14.2278 2.16648 13.7842 2.33767 13.4056 2.16969C11.2163 1.19872 8.6115 1.25212 6.38116 2.53981C2.89345 4.55388 1.5639 8.86997 3.20245 12.4607L3.48956 11.3904C3.5969 10.9908 4.00875 10.7533 4.40851 10.8601C4.80853 10.9673 5.04583 11.379 4.93878 11.7791L4.20636 14.5115C4.1548 14.7033 4.02971 14.8672 3.85773 14.9666C3.68557 15.0659 3.48039 15.0931 3.28839 15.0418L0.555969 14.3093C0.156297 14.2018 -0.0814473 13.7903 0.0256958 13.3904C0.133068 12.9908 0.544873 12.7533 0.944641 12.8601L1.84698 13.1023C-0.12336 8.81234 1.46136 3.64765 5.63116 1.24Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function RefreshCw01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M9.75 0C12.4434 0 14.8827 1.09342 16.6465 2.8584C17.441 3.65349 18.3097 4.68864 19 5.55078V1.75C19 1.33579 19.3358 1 19.75 1C20.1642 1 20.5 1.33579 20.5 1.75V7.75C20.5 8.16421 20.1642 8.5 19.75 8.5H13.75C13.3358 8.5 13 8.16421 13 7.75C13 7.33579 13.3358 7 13.75 7H18.2334C18.1453 6.88748 18.0536 6.76899 17.957 6.64746C17.2564 5.76611 16.3694 4.70193 15.5859 3.91797C14.092 2.42304 12.0294 1.5 9.75 1.5C5.19365 1.5 1.5 5.19365 1.5 9.75C1.5 14.3063 5.19365 18 9.75 18C13.5101 18 16.6845 15.4839 17.6777 12.042C17.7926 11.6441 18.2085 11.4145 18.6064 11.5293C19.0043 11.6442 19.2339 12.0601 19.1191 12.458C17.9456 16.5247 14.1961 19.5 9.75 19.5C4.36522 19.5 0 15.1348 0 9.75C0 4.36522 4.36522 0 9.75 0Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function RefreshCw02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M6.75 11.0001C7.16413 11.0001 7.49987 11.336 7.5 11.7501C7.5 12.1643 7.16421 12.5001 6.75 12.5001H2.10352C2.59817 13.1361 3.45119 14.1193 4.91602 15.5841C8.13784 18.8059 13.3622 18.8059 16.584 15.5841C17.7262 14.4418 18.4625 13.0494 18.7949 11.5841C18.8867 11.1804 19.2886 10.9271 19.6924 11.0187C20.0961 11.1104 20.3493 11.5123 20.2578 11.9161C19.8646 13.6493 18.9927 15.2964 17.6445 16.6447C13.8369 20.4523 7.66308 20.4523 3.85547 16.6447C2.80486 15.594 2.04774 14.7707 1.5 14.13V17.7501C1.5 18.1643 1.16421 18.5001 0.75 18.5001C0.335786 18.5001 0 18.1643 0 17.7501V11.7501C0.000129723 11.336 0.335866 11.0001 0.75 11.0001H6.75Z"
          fill="currentColor"
        />
        <path
          d="M3.85547 2.85559C7.66305 -0.951863 13.8369 -0.951863 17.6445 2.85559C18.6948 3.90587 19.4523 4.72866 20 5.36926V1.75012C20.0001 1.33602 20.3359 1.00012 20.75 1.00012C21.1641 1.00012 21.4999 1.33602 21.5 1.75012V7.75012C21.5 8.16433 21.1642 8.50012 20.75 8.50012H14.75C14.3358 8.50012 14 8.16433 14 7.75012C14.0001 7.33602 14.3359 7.00012 14.75 7.00012H19.3965C18.9018 6.36408 18.0488 5.38092 16.584 3.91614C13.3622 0.69447 8.13781 0.69447 4.91602 3.91614C3.77376 5.05839 3.03758 6.45087 2.70508 7.91614C2.61338 8.32003 2.21153 8.57321 1.80762 8.48157C1.40384 8.38979 1.15056 7.98795 1.24219 7.5841C1.63547 5.85097 2.5073 4.20376 3.85547 2.85559Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function RefreshCw03Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 1.25)">
        <path
          d="M11.0187 1.80762C11.1104 1.40387 11.5123 1.15067 11.9161 1.24219C13.6493 1.63543 15.2964 2.50729 16.6446 3.85547C20.4522 7.66308 20.4522 13.8369 16.6446 17.6445C15.594 18.6951 14.7707 19.4523 14.13 20H17.7501C18.1643 20 18.5001 20.3358 18.5001 20.75C18.5001 21.1642 18.1643 21.5 17.7501 21.5H11.7501C11.5513 21.4999 11.3604 21.4209 11.2198 21.2803C11.0792 21.1396 11.0001 20.9489 11.0001 20.75V14.75C11.0001 14.3358 11.336 14.0001 11.7501 14C12.1643 14 12.5001 14.3358 12.5001 14.75V19.3965C13.1361 18.9018 14.1192 18.0488 15.5841 16.584C18.8059 13.3622 18.8059 8.13784 15.5841 4.91602C14.4418 3.77376 13.0494 3.03754 11.5841 2.70508C11.1803 2.61331 10.927 2.21146 11.0187 1.80762Z"
          fill="currentColor"
        />
        <path
          d="M7.7501 0C8.16423 1.34089e-05 8.49999 0.335885 8.5001 0.75V6.75C8.5001 7.16421 8.16431 7.5 7.7501 7.5C7.33597 7.4999 7.0001 7.16415 7.0001 6.75V2.10254C6.36408 2.59716 5.38136 3.45175 3.91611 4.91699C0.694836 8.13879 0.694641 13.3623 3.91611 16.584C5.05838 17.7263 6.45083 18.4624 7.91611 18.7949C8.32003 18.8866 8.57319 19.2885 8.48154 19.6924C8.38985 20.0963 7.98799 20.3495 7.58408 20.2578C5.85094 19.8645 4.20374 18.9927 2.85556 17.6445C-0.951822 13.8369 -0.951887 7.66302 2.85556 3.85547C3.90618 2.80486 4.72953 2.04774 5.37021 1.5H1.7501C1.33598 1.49988 1.0001 1.16414 1.0001 0.75C1.00011 0.335858 1.33598 0.00010267 1.7501 0H7.7501Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function RefreshCw04Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.75, 0.85)">
        <path
          d="M13.6436 3.83371C13.8874 3.49933 14.3567 3.42526 14.6914 3.66867C16.9981 5.34922 18.4999 8.0749 18.5 11.1501C18.4998 15.9657 14.8194 19.9194 10.1182 20.3571L10.7803 21.0193C11.0731 21.312 11.0729 21.7869 10.7803 22.0798C10.4874 22.3727 10.0126 22.3727 9.71973 22.0798L7.71973 20.0798C7.42715 19.7869 7.42694 19.312 7.71973 19.0193L9.71973 17.0193C10.0125 16.7268 10.4875 16.7268 10.7803 17.0193C11.0731 17.312 11.0729 17.7869 10.7803 18.0798L9.99609 18.863C13.9261 18.4875 16.9998 15.1784 17 11.1501C16.9999 8.57474 15.7442 6.29194 13.8086 4.88156C13.4741 4.63768 13.3999 4.16841 13.6436 3.83371Z"
          fill="currentColor"
        />
        <path
          d="M7.71973 0.219454C8.01257 -0.0731514 8.48744 -0.0731514 8.78027 0.219454L10.7803 2.21945C11.0731 2.51228 11.073 2.98709 10.7803 3.28L8.78027 5.28C8.48738 5.57289 8.01262 5.57289 7.71973 5.28C7.42705 4.98709 7.42691 4.51228 7.71973 4.21945L8.50195 3.43625C4.5729 3.81259 1.50022 7.12248 1.5 11.1501C1.50013 13.7254 2.75592 16.0073 4.69141 17.4177C5.02596 17.6614 5.09976 18.1308 4.85645 18.4655C4.61258 18.8003 4.14336 18.8743 3.80859 18.6306C1.50205 16.95 0.000127266 14.2253 0 11.1501C0.000219867 6.33481 3.67998 2.37926 8.38086 1.94113L7.71973 1.28C7.42705 0.98709 7.42691 0.512275 7.71973 0.219454Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function RefreshCw05Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.74, 2.75)">
        <path
          d="M17.7894 9.39827C18.201 9.44209 18.4997 9.81192 18.4564 10.2235C18.1543 13.0615 16.5445 15.7248 13.8812 17.2625C9.71077 19.6701 4.44594 18.4605 1.71614 14.6082L1.47493 15.5116C1.36772 15.9117 0.95608 16.149 0.55598 16.0418C0.156215 15.9344 -0.0814502 15.5228 0.0257067 15.1229L0.758129 12.3914L0.781566 12.3182C0.916603 11.9633 1.30134 11.7611 1.6761 11.8612L4.40852 12.5926C4.80849 12.6998 5.04574 13.1116 4.93879 13.5116C4.83159 13.9117 4.41995 14.149 4.01985 14.0418L2.94953 13.7547C5.23968 16.9703 9.64252 17.9776 13.1312 15.9637C15.3617 14.6759 16.7106 12.447 16.9642 10.0653C17.0082 9.65375 17.3778 9.35471 17.7894 9.39827Z"
          fill="currentColor"
        />
        <path
          d="M4.63215 1.24007C8.80215 -1.16718 14.0662 0.0429929 16.7962 3.89437L17.0394 2.99105C17.1468 2.5916 17.5577 2.35413 17.9573 2.46077C18.3573 2.56795 18.5946 2.97973 18.4876 3.37972L17.7562 6.11117C17.7047 6.30329 17.5788 6.46776 17.4066 6.56722C17.2343 6.66662 17.0293 6.69389 16.8372 6.64242L14.1058 5.90999C13.7059 5.80265 13.4683 5.39104 13.5755 4.99105C13.683 4.59156 14.0938 4.35399 14.4935 4.46077L15.5628 4.74691C13.2722 1.53257 8.87023 0.526107 5.38215 2.53988C3.15183 3.82755 1.80291 6.0559 1.54914 8.43734C1.5053 8.8492 1.13581 9.14813 0.723949 9.10433C0.312215 9.06036 0.0141247 8.69091 0.0579332 8.27913C0.360132 5.44127 1.96891 2.77769 4.63215 1.24007Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ReverseLeftIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(3.25, 2.25)">
        <path
          d="M4.21973 0.21967C4.51262 -0.0732233 4.98738 -0.0732233 5.28027 0.21967C5.57314 0.512565 5.57316 0.987333 5.28027 1.28022L2.56055 3.99994H10.75C14.4779 3.99994 17.5 7.02202 17.5 10.7499C17.5 14.4778 14.4779 17.4999 10.75 17.4999H0.75C0.335805 17.4999 3.06649e-05 17.1641 0 16.7499C0 16.3357 0.335786 15.9999 0.75 15.9999H10.75C13.6495 15.9999 16 13.6494 16 10.7499C16 7.85045 13.6495 5.49994 10.75 5.49994H2.56055L5.28027 8.21967C5.57314 8.51257 5.57316 8.98733 5.28027 9.28022C4.98739 9.57307 4.51261 9.57307 4.21973 9.28022L0.219727 5.28022C-0.0731571 4.98733 -0.0731382 4.51257 0.219727 4.21967L4.21973 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function ReverseRightIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(3.25, 2.25)">
        <path
          d="M12.2197 0.21967C12.5126 -0.0732233 12.9874 -0.0732233 13.2803 0.21967L17.2803 4.21967C17.5731 4.51257 17.5732 4.98733 17.2803 5.28022L13.2803 9.28022C12.9874 9.57307 12.5126 9.57307 12.2197 9.28022C11.9268 8.98733 11.9269 8.51257 12.2197 8.21967L14.9395 5.49994H6.75C3.85051 5.49994 1.5 7.85045 1.5 10.7499C1.50003 13.6494 3.85052 15.9999 6.75 15.9999H16.75C17.1642 15.9999 17.5 16.3357 17.5 16.7499C17.5 17.1641 17.1642 17.4999 16.75 17.4999H6.75C3.0221 17.4999 3.06673e-05 14.4778 0 10.7499C0 7.02202 3.02208 3.99994 6.75 3.99994H14.9395L12.2197 1.28022C11.9268 0.987333 11.9269 0.512565 12.2197 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function SwitchHorizontal01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(3.25, 2.25)">
        <path
          d="M4.21973 10.2197C4.51262 9.92678 4.98738 9.92678 5.28027 10.2197C5.57314 10.5126 5.57316 10.9873 5.28027 11.2802L2.56055 13.9999H16.75C17.1642 13.9999 17.5 14.3357 17.5 14.7499C17.5 15.1641 17.1642 15.4999 16.75 15.4999H2.56055L5.28027 18.2197C5.57314 18.5126 5.57316 18.9873 5.28027 19.2802C4.98739 19.5731 4.51261 19.5731 4.21973 19.2802L0.219727 15.2802C-0.0731572 14.9873 -0.0731382 14.5126 0.219727 14.2197L4.21973 10.2197Z"
          fill="currentColor"
        />
        <path
          d="M12.2197 0.21967C12.5126 -0.0732233 12.9874 -0.0732233 13.2803 0.21967L17.2803 4.21967C17.5731 4.51257 17.5732 4.98733 17.2803 5.28022L13.2803 9.28022C12.9874 9.57307 12.5126 9.57307 12.2197 9.28022C11.9268 8.98733 11.9269 8.51257 12.2197 8.21967L14.9395 5.49994H0.75C0.335805 5.49994 3.06649e-05 5.16413 0 4.74994C0 4.33573 0.335786 3.99994 0.75 3.99994H14.9395L12.2197 1.28022C11.9268 0.987333 11.9269 0.512565 12.2197 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function SwitchHorizontal02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(3.25, 2.25)">
        <path
          d="M12.2197 10.2197C12.5126 9.92678 12.9874 9.92678 13.2803 10.2197L17.2803 14.2197C17.5731 14.5126 17.5732 14.9873 17.2803 15.2802L13.2803 19.2802C12.9874 19.5731 12.5126 19.5731 12.2197 19.2802C11.9268 18.9873 11.9269 18.5126 12.2197 18.2197L14.9395 15.4999H0.75C0.335805 15.4999 3.06649e-05 15.1641 0 14.7499C0 14.3357 0.335786 13.9999 0.75 13.9999H14.9395L12.2197 11.2802C11.9268 10.9873 11.9269 10.5126 12.2197 10.2197Z"
          fill="currentColor"
        />
        <path
          d="M4.21973 0.21967C4.51262 -0.0732233 4.98738 -0.0732233 5.28027 0.21967C5.57314 0.512565 5.57316 0.987333 5.28027 1.28022L2.56055 3.99994H16.75C17.1642 3.99994 17.5 4.33573 17.5 4.74994C17.5 5.16413 17.1642 5.49994 16.75 5.49994H2.56055L5.28027 8.21967C5.57314 8.51257 5.57316 8.98733 5.28027 9.28022C4.98739 9.57307 4.51261 9.57307 4.21973 9.28022L0.219727 5.28022C-0.0731571 4.98733 -0.0731382 4.51257 0.219727 4.21967L4.21973 0.21967Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function SwitchVertical01Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 3.25)">
        <path
          d="M4.2763 0.168031C4.57086 -0.0721909 5.00562 -0.0547575 5.2802 0.219789L9.2802 4.21979C9.57307 4.51265 9.57301 4.98744 9.2802 5.28034C8.98731 5.57323 8.51255 5.57323 8.21966 5.28034L5.49993 2.56061V16.7501C5.49993 17.1643 5.16412 17.5 4.74993 17.5001C4.33571 17.5001 3.99993 17.1643 3.99993 16.7501V2.56061L1.2802 5.28034C0.987308 5.57323 0.512548 5.57323 0.219655 5.28034C-0.0732083 4.98744 -0.0732283 4.51267 0.219655 4.21979L4.21966 0.219789L4.2763 0.168031Z"
          fill="currentColor"
        />
        <path
          d="M14.7499 6.24581e-05C15.1641 9.31155e-05 15.4999 0.335921 15.4999 0.750062V14.9395L18.2197 12.2198C18.5125 11.927 18.9873 11.927 19.2802 12.2198C19.5731 12.5127 19.573 12.9874 19.2802 13.2803L15.2802 17.2803C14.9873 17.5732 14.5125 17.5732 14.2197 17.2803L10.2197 13.2803C9.92679 12.9874 9.92677 12.5127 10.2197 12.2198C10.5125 11.927 10.9873 11.927 11.2802 12.2198L13.9999 14.9395V0.750062C14 0.335903 14.3358 6.24581e-05 14.7499 6.24581e-05Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function SwitchVertical02Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 3.25)">
        <path
          d="M4.74993 6.24632e-05C5.16408 9.31204e-05 5.49987 0.335922 5.49993 0.750062V14.9395L8.21966 12.2198C8.51255 11.927 8.98734 11.927 9.2802 12.2198C9.57307 12.5127 9.57301 12.9874 9.2802 13.2803L5.2802 17.2803C4.98731 17.5732 4.51255 17.5732 4.21966 17.2803L0.219655 13.2803C-0.0732082 12.9874 -0.0732283 12.5127 0.219655 12.2198C0.512545 11.927 0.987335 11.927 1.2802 12.2198L3.99993 14.9395V0.750062C3.99999 0.335903 4.33575 6.24632e-05 4.74993 6.24632e-05Z"
          fill="currentColor"
        />
        <path
          d="M14.2763 0.168031C14.5709 -0.0721909 15.0056 -0.0547575 15.2802 0.219789L19.2802 4.21979C19.5731 4.51265 19.573 4.98744 19.2802 5.28034C18.9873 5.57323 18.5125 5.57323 18.2197 5.28034L15.4999 2.56061V16.7501C15.4999 17.1643 15.1641 17.5 14.7499 17.5001C14.3357 17.5001 13.9999 17.1643 13.9999 16.7501V2.56061L11.2802 5.28034C10.9873 5.57323 10.5125 5.57323 10.2197 5.28034C9.92679 4.98744 9.92677 4.51267 10.2197 4.21979L14.2197 0.219789L14.2763 0.168031Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

export function WidthIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 2.25)">
        <path
          d="M13.043 7.04297C13.4335 6.65245 14.0665 6.65245 14.457 7.04297L16.457 9.04297C16.8476 9.4335 16.8476 10.0665 16.457 10.457L14.457 12.457C14.0665 12.8476 13.4335 12.8476 13.043 12.457C12.6524 12.0665 12.6524 11.4335 13.043 11.043L13.5859 10.5H11.75C11.3358 10.5 11 10.1642 11 9.75C11 9.33579 11.3358 9 11.75 9H13.5859L13.043 8.45703C12.6524 8.06651 12.6524 7.43349 13.043 7.04297Z"
          fill="currentColor"
        />
        <path
          d="M5.21973 7.21973C5.51262 6.92684 5.98738 6.92684 6.28028 7.21973C6.57317 7.51262 6.57317 7.98738 6.28028 8.28028L5.56055 9H7.75C8.16421 9 8.5 9.33579 8.5 9.75C8.5 10.1642 8.16422 10.5 7.75 10.5H5.56055L6.28028 11.2197C6.57317 11.5126 6.57317 11.9874 6.28028 12.2803C5.98738 12.5732 5.51262 12.5732 5.21973 12.2803L3.21973 10.2803C3.17101 10.2316 3.1331 10.1763 3.10059 10.1191C3.08497 10.0917 3.06876 10.0646 3.05664 10.0352C3.03621 9.98543 3.02101 9.93411 3.01172 9.88184C3.00413 9.83903 3 9.79499 3 9.75C3 9.70468 3.00402 9.6603 3.01172 9.61719C3.02082 9.56636 3.03505 9.51621 3.05469 9.46778L3.0586 9.45801C3.0711 9.42843 3.08844 9.40152 3.10449 9.37403C3.13633 9.31946 3.17296 9.2665 3.21973 9.21973L5.21973 7.21973Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9502 1.74497e-06C14.7778 1.65386e-06 15.4436 -0.000968084 15.9814 0.0429705C16.5281 0.0876302 17.008 0.182866 17.4522 0.409181C18.1578 0.768706 18.7313 1.34225 19.0908 2.04785C19.3171 2.49205 19.4124 2.97195 19.457 3.51856C19.501 4.05639 19.5 4.72222 19.5 5.54981V13.9502C19.5 14.7778 19.501 15.4436 19.457 15.9814C19.4124 16.5281 19.3171 17.008 19.0908 17.4522C18.7313 18.1578 18.1578 18.7313 17.4522 19.0908C17.008 19.3171 16.5281 19.4124 15.9814 19.457C15.4436 19.501 14.7778 19.5 13.9502 19.5H5.54981C4.72222 19.5 4.05639 19.501 3.51856 19.457C2.97195 19.4124 2.49205 19.3171 2.04785 19.0908C1.34225 18.7313 0.768706 18.1578 0.409181 17.4522C0.182866 17.008 0.0876302 16.5281 0.0429705 15.9814C-0.000968147 15.4436 1.65333e-06 14.7778 1.74489e-06 13.9502V5.54981C1.65225e-06 4.72222 -0.000968195 4.05639 0.0429705 3.51856C0.0876303 2.97195 0.182866 2.49205 0.409181 2.04785C0.768706 1.34225 1.34225 0.768706 2.04785 0.409181C2.49205 0.182866 2.97195 0.0876303 3.51856 0.0429705C4.05639 -0.000968207 4.72222 1.65211e-06 5.54981 1.74497e-06H13.9502ZM5.54981 1.5C4.69746 1.5 4.10322 1.50029 3.64063 1.53809C3.1868 1.57517 2.92602 1.64449 2.72852 1.74512C2.30515 1.96083 1.96083 2.30515 1.74512 2.72852C1.64449 2.92602 1.57517 3.1868 1.53809 3.64063C1.50029 4.10322 1.5 4.69746 1.5 5.54981V13.9502C1.5 14.8025 1.50029 15.3968 1.53809 15.8594C1.57517 16.3132 1.64449 16.574 1.74512 16.7715C1.96083 17.1949 2.30515 17.5392 2.72852 17.7549C2.92602 17.8555 3.1868 17.9248 3.64063 17.9619C4.10322 17.9997 4.69746 18 5.54981 18H13.9502C14.8025 18 15.3968 17.9997 15.8594 17.9619C16.3132 17.9248 16.574 17.8555 16.7715 17.7549C17.1949 17.5392 17.5392 17.1949 17.7549 16.7715C17.8555 16.574 17.9248 16.3132 17.9619 15.8594C17.9997 15.3968 18 14.8025 18 13.9502V5.54981C18 4.69746 17.9997 4.10322 17.9619 3.64063C17.9248 3.1868 17.8555 2.92602 17.7549 2.72852C17.5392 2.30515 17.1949 1.96083 16.7715 1.74512C16.574 1.64449 16.3132 1.57517 15.8594 1.53809C15.3968 1.50029 14.8025 1.5 13.9502 1.5H5.54981Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
